export const ruTranslations = {
  langSwitcher: {
    aria: 'Сменить язык',
    ru: 'Русский',
    en: 'English',
  },

  nav: {
    blog: 'Блог',
  },

  badge: {
    local: 'Локально',
    localTitle: 'Файл обрабатывается прямо в браузере и не отправляется на сервер',
  },

  units: {
    mib: 'МиБ',
    kib: 'КиБ',
    mb: 'МБ',
  },

  common: {
    download: 'Скачать',
    retry: 'Попробовать ещё раз',
    errorTitle: 'Ошибка',
    done: 'Готово',
    file: 'Файл',
    size: 'Размер',
    sourceSize: 'Исходный размер',
    pickPdf: 'Выберите PDF-файл',
    pickExcel: 'Выберите таблицу Excel',
    pickFile: 'Выберите файл',
    deleteFile: 'Удалить файл',
    dragPdf: 'Перетащите PDF сюда или ',
    dragExcel: 'Перетащите XLSX, XLS или ODS сюда или ',
    clickToPick: 'нажмите для выбора',
    pdfLimit: 'Только PDF, не более {size} МБ',
    sizeLimit: 'До {size} МБ',
    localBadge: 'Файл не уходит на сервер — обработка в вашем браузере',
    tooLarge: 'Файл больше {size} МБ — мы пока не умеем такие.',
  },

  pdfViewer: {
    pickFile: 'Выберите PDF или перетащите его сюда',
    limit: 'Один PDF до {size} МБ и {pages} страниц',
    localNotice: 'PDF остаётся на вашем устройстве: в сеть уходят только обычные ресурсы страницы, но не байты документа.',
    opening: 'Открываем PDF локально…',
    rendering: 'Рендерим страницу…',
    previewTitle: 'Просмотр PDF',
    fit: 'Вписать',
    zoomOut: 'Уменьшить масштаб',
    zoomIn: 'Увеличить масштаб',
    previous: 'Назад',
    next: 'Вперёд',
    pageOf: 'Страница {page} из {pages}',
    pageAlt: 'Страница PDF {page}',
    reset: 'Закрыть PDF',
    chooseAnother: 'Выбрать другой PDF',
    errorTitle: 'Не удалось открыть PDF',
    fileInfo: 'Сведения о файле',
    fileName: 'Имя файла',
    fileSize: 'Размер файла',
    pageCount: 'Количество страниц',
    actionsTitle: 'Продолжить работу с PDF',
    actionsDescription: 'Исходный файл не передаётся автоматически. Выберите действие и добавьте PDF на странице инструмента.',
    errors: {
      empty: 'Файл пуст. Выберите непустой PDF.',
      unsupported: 'Поддерживаются только PDF-файлы.',
      too_large: 'PDF превышает лимит 32 МБ. Уменьшите файл и попробуйте снова.',
      corrupt: 'PDF повреждён или имеет неверную структуру. Попробуйте открыть другую копию файла.',
      encrypted: 'PDF защищён паролем или зашифрован. Сначала снимите защиту, затем откройте файл снова.',
      no_pages: 'В PDF нет страниц для просмотра.',
      too_many_pages: 'В PDF больше 400 страниц. Разделите документ на части перед просмотром.',
      unsafe_structure: 'Структура PDF превышает безопасные локальные лимиты. Пересохраните документ или разделите его на части.',
      page_too_large: 'Размер страницы слишком велик для безопасного рендера в браузере.',
      canvas_unavailable: 'Браузер не поддерживает безопасный рендер страницы. Попробуйте актуальную версию браузера.',
      timeout: 'Открытие или рендер страницы заняли слишком много времени и были остановлены.',
      render_failed: 'Не удалось отобразить эту страницу. Перейдите на другую страницу или выберите другой PDF.',
    },
  },

  hero: {
    title: 'Все инструменты для работы с PDF — онлайн и бесплатно',
    sub: 'Всё работает в браузере: файл остаётся на вашем устройстве. Без регистрации и водяных знаков.',
    searchLabel: 'Найти инструмент',
    searchPlaceholder: 'Что нужно сделать? Например, сжать или объединить',
    noResults: 'Ничего не нашлось. Попробуйте другое слово или откройте весь каталог.',
    clearSearch: 'Показать все инструменты',
    toolsLabel: 'Инструменты',
    categoryLabels: {
      compression: {
        title: 'Сжатие PDF',
        description: 'Уменьшайте размер файла прямо в браузере.',
      },
      'pdf-conversion': {
        title: 'Конвертация PDF',
        description: 'Переводите PDF в текст, собирайте PDF из HTML и таблиц Excel.',
      },
      'pdf-editing': {
        title: 'Редактирование PDF',
        description: 'Поворачивайте, объединяйте, разделяйте, обрезайте и приводите PDF в порядок.',
      },
      'image-pdf': {
        title: 'Картинки и PDF',
        description: 'Переводите страницы PDF в изображения и собирайте PDF из JPG, PNG или HEIC.',
      },
      security: {
        title: 'Пароли и безопасность',
        description: 'Добавляйте пароль или снимайте известный пароль открытия без лишних аккаунтов.',
      },
    },
    aboutLabel: 'О сервисе',
    aboutTitle: 'PDF-инструменты, которые работают в браузере',
    aboutPara1Prefix:
      'pdfy.ru — бесплатный набор PDF-инструментов. Файл обрабатывается на вашем устройстве и никуда не отправляется: ',
    aboutPara1Tool1: '«повернуть PDF»',
    aboutPara1Mid: ' и ',
    aboutPara1Tool2: '«PDF в JPG»',
    aboutPara1Suffix:
      ', «JPG в PDF», «HEIC в PDF» и «PDF в текст» работают через pdf-lib, pdf.js и WASM-декодер HEIC. Это легко проверить: откройте вкладку Network в инструментах разработчика — запросов с вашим файлом там нет.',
    aboutPara3:
      'Без регистрации, без водяных знаков на результате и без платных тарифов. Доступны сжатие, конвертация, объединение, разделение, обрезка, нумерация, водяные знаки, пароли и сборка PDF из JPG, PNG или HEIC.',
  },

  tool: {
    crossPromoHeading: 'Похожие PDF-инструменты',
    crossPromoAllTools: 'Все PDF-инструменты',
    faqHeading: 'Частые вопросы',
    howToHeading: 'Как это работает',
  },

  pdfPreview: {
    title: 'Предпросмотр страниц',
    description: 'Проверьте документ перед скачиванием результата.',
    totalPages: 'Страниц: {pages}',
    renderedPages: 'Показано миниатюр: {shown} из {total}.',
    limited: 'Для больших PDF рендерим первые {limit} страниц, остальные остаются доступными по номерам.',
    failed: 'Не удалось показать миниатюры. Можно продолжить по номерам страниц.',
    loading: 'Превью…',
    pageLabel: 'Стр. {page}',
    pageAlt: 'Страница {page}',
    selected: 'Выбрано',
    removed: 'Удалить',
    rotated: 'Поворот',
  },

  signPdf: {
    notice: 'Инструмент добавляет визуальную подпись или штамп. Это не КЭП, не сертификатная цифровая подпись и не юридическая консультация.',
    dropPdf: 'Перетащите PDF сюда или выберите файл',
    processedLocally: 'обработка локально',
    chooseAnother: 'Другой файл',
    type: 'Напечатать',
    draw: 'Нарисовать',
    upload: 'Загрузить PNG/JPG',
    signatureText: 'Текст подписи',
    signaturePlaceholder: 'Имя или подпись',
    create: 'Создать',
    useDrawing: 'Использовать рисунок',
    clear: 'Очистить',
    createdSignature: 'Созданная подпись',
    instructions: 'Выберите страницы. На активном превью перетащите подпись; маркер справа снизу меняет размер.',
    preparingPreview: 'Готовим превью страниц…',
    partialPreview: 'Часть превью недоступна, но все страницы можно выбрать по номерам.',
    previewError: 'Не удалось прочитать PDF и определить страницы. Выберите другой файл.',
    showingPreviews: 'Показаны первые {limit} превью из {total}; остальные страницы доступны по номерам.',
    pagesToSign: 'Страницы для подписи',
    rangesPlaceholder: 'Например: 1-3, 7, 10-12',
    apply: 'Применить',
    invalidPages: 'Введите не более {limit} страниц от 1 до {total}.',
    selectAll: 'Выбрать все',
    maxPages: 'За один раз можно подписать не более {limit} страниц.',
    clearSelection: 'Снять выбор',
    selectedCount: 'Выбрано: {selected} из {limit}',
    page: 'Страница',
    signaturePosition: 'Положение подписи на странице {page}. Стрелки перемещают подпись.',
    resizeSignature: 'Изменить размер подписи. Стрелки меняют ширину и высоту.',
    noPreview: 'Без превью',
    adding: 'Добавляем подпись…',
    creating: 'Создаём подпись…',
    add: 'Добавить визуальную подпись',
    download: 'Скачать подписанный PDF',
    choosePdf: 'Выберите PDF-файл.',
    fileTooLarge: 'Файл больше 100 МБ.',
    emptyText: 'Введите текст подписи.',
    typedError: 'Не удалось создать текстовую подпись.',
    emptyDrawing: 'Сначала нарисуйте подпись.',
    drawingError: 'Не удалось сохранить нарисованную подпись.',
    invalidImage: 'Выберите PNG или JPG размером до 10 МБ.',
    imageTooLarge: 'Изображение слишком большое. Максимум — 25 мегапикселей.',
    imageError: 'Не удалось прочитать изображение подписи. Проверьте PNG/JPG.',
    saveError: 'Не удалось добавить подпись. Проверьте PDF и попробуйте снова.',
  },

  jpgVPdf: {
    pickImages: 'Выберите JPG или PNG изображения',
    dropImages: 'Перетащите JPG или PNG сюда или ',
    limit: 'JPG/PNG, суммарно до {size} МБ',
    selectedCount: 'Выбрано файлов: {count}',
    unsupportedFiles: 'Некоторые файлы пропущены: поддерживаются только JPG, JPEG и PNG.',
    unsupportedBrowser:
      'Ваш браузер не поддерживает WebAssembly или Web Workers, которые нужны для локального HEIC-декодера. Попробуйте актуальный Chrome, Safari, Firefox или Edge.',
    tooLarge: 'Суммарный размер больше {size} МБ — уменьшите изображения или выберите меньше файлов.',
    conversionError:
      'Не удалось собрать PDF. Проверьте, что изображения не повреждены, и попробуйте ещё раз.',
    successDetails: 'PDF готов, размер файла: {size}.',
    convert: 'Собрать PDF',
    processing: 'Собираем PDF…',
    downloadPdf: 'Скачать PDF',
    clear: 'Очистить',
  },

  'png-v-pdf': {
    pickImages: 'Выберите PNG изображения',
    dropImages: 'Перетащите PNG сюда или ',
    limit: 'PNG/JPG, суммарно до {size} МБ',
    selectedCount: 'Выбрано файлов: {count}',
    unsupportedFiles: 'Некоторые файлы пропущены: поддерживаются PNG, JPG и JPEG.',
    unsupportedBrowser:
      'Ваш браузер не поддерживает WebAssembly или Web Workers, которые нужны для локального HEIC-декодера. Попробуйте актуальный Chrome, Safari, Firefox или Edge.',
    tooLarge: 'Суммарный размер больше {size} МБ — уменьшите изображения или выберите меньше файлов.',
    conversionError:
      'Не удалось собрать PDF. Проверьте, что PNG не повреждены, и попробуйте ещё раз.',
    successDetails: 'PDF готов, размер файла: {size}.',
    convert: 'Собрать PDF',
    processing: 'Собираем PDF…',
    downloadPdf: 'Скачать PDF',
    clear: 'Очистить',
  },

  heicVPdf: {
    pickImages: 'Выберите HEIC или HEIF фотографии',
    dropImages: 'Перетащите HEIC или HEIF сюда или ',
    limit: 'HEIC/HEIF, суммарно до {size} МБ',
    selectedCount: 'Выбрано файлов: {count}',
    unsupportedFiles: 'Некоторые файлы пропущены: поддерживаются только HEIC и HEIF.',
    unsupportedBrowser:
      'Ваш браузер не поддерживает WebAssembly или Web Workers, которые нужны для локального HEIC-декодера. Попробуйте актуальный Chrome, Safari, Firefox или Edge.',
    tooLarge: 'Суммарный размер больше {size} МБ — уменьшите фотографии или выберите меньше файлов.',
    conversionError:
      'Не удалось прочитать HEIC/HEIF и собрать PDF. Проверьте, что файл не повреждён, и попробуйте другую фотографию.',
    successDetails: 'PDF готов, размер файла: {size}.',
    convert: 'Собрать PDF',
    processing: 'Декодируем HEIC и собираем PDF…',
    downloadPdf: 'Скачать PDF',
    clear: 'Очистить',
  },

  htmlToPdf: {
    pasteMode: 'Вставить HTML',
    fileMode: 'HTML-файл',
    textareaLabel: 'HTML-код',
    fileTextareaLabel: 'HTML из файла',
    placeholder: '<h1>Заголовок</h1>\n<p>Текст документа...</p>',
    inputStats: 'Символов: {chars} · объём: {bytes}',
    limit: 'До {chars} символов или HTML-файл до {size} МБ',
    localNotice:
      'Всё работает локально: вставленный HTML и HTML-файлы не отправляются на сервер. Ссылки на страницы инструмент не открывает.',
    emptyHtml: 'Вставьте HTML-код или загрузите .html/.htm файл.',
    tooLarge:
      'HTML слишком большой. Ограничение: до {chars} символов в поле или HTML-файл до {size} МБ.',
    unsupportedFile: 'Поддерживаются только .html и .htm файлы.',
    unsupportedBrowser:
      'Ваш браузер не поддерживает локальную генерацию PDF. Попробуйте актуальный Chrome, Safari, Firefox или Edge.',
    conversionError:
      'Не удалось создать PDF из этого HTML. Проверьте разметку и попробуйте убрать внешние скрипты или тяжёлые изображения.',
    successDetails: 'PDF готов, размер файла: {size}.',
    convert: 'Создать PDF',
    processing: 'Создаём PDF...',
    downloadPdf: 'Скачать PDF',
    useSample: 'Вставить пример',
    clear: 'Очистить',
  },

  pdfToText: {
    noOcrNotice:
      'Извлекаем только уже существующий текстовый слой PDF. Сканированные страницы и картинки без OCR не распознаются.',
    submit: 'Извлечь текст',
    loading: 'Извлекаем текст…',
    progressTitle: 'Читаем PDF',
    progressPages: 'Страница {current} из {total}',
    previewTitle: 'Предпросмотр текста',
    downloadTxt: 'Скачать TXT',
    clear: 'Выбрать другой PDF',
    resultStats: 'Страниц: {pages} · слов: {words} · символов без пробелов: {chars}',
    tooLittleTextWarning:
      'Текста найдено очень мало. Возможно, PDF состоит из сканов или картинок — для такого файла нужен OCR, которого в этом инструменте пока нет.',
    noTextLayer:
      'Текстовый слой не найден. Скорее всего, это скан или PDF из картинок. Этот инструмент не делает OCR, поэтому распознать такой файл не сможет.',
    encrypted:
      'PDF защищён паролем или зашифрован. Снимите защиту и попробуйте ещё раз.',
    invalidPdf:
      'Не удалось открыть PDF. Проверьте, что файл не повреждён и действительно является PDF.',
    extractError:
      'Не удалось извлечь текст из этого PDF. Попробуйте другой файл.',
  },

  comparePdf: {
    leftFile: 'Первый PDF',
    rightFile: 'Второй PDF',
    scopeNotice:
      'Инструмент сравнивает текстовый слой PDF постранично и не делает OCR. Сканированные документы, PDF из картинок и документы больше {pages} страниц получают понятное сообщение вместо пустого результата.',
    submit: 'Сравнить PDF',
    loading: 'Сравниваем PDF…',
    progressLeft: 'Читаем первый PDF',
    progressRight: 'Читаем второй PDF',
    progressCompare: 'Сравниваем текст',
    progressPages: 'Страница {current} из {total}',
    identicalTitle: 'Текстовый слой совпадает',
    differentTitle: 'Найдены отличия в тексте',
    resultFiles: '{left} ↔ {right}',
    equalPages: 'Совпали страницы',
    changedPages: 'Изменены',
    addedPages: 'Добавлены',
    removedPages: 'Удалены',
    pageCount: 'Страницы',
    wordCount: 'Слова',
    similarity: 'Совпадение страниц',
    lowTextWarning:
      'В одном из PDF найдено очень мало текста. Если это скан или картинка, полноценное сравнение требует OCR и может быть неполным.',
    diffHeading: 'Изменения по страницам',
    pageChanged: 'Страница {page}: изменён текст',
    pageAdded: 'Страница {page}: добавлена во втором PDF',
    pageRemoved: 'Страница {page}: удалена из второго PDF',
    diffStats: 'Удалено строк: {removed} · добавлено строк: {added}',
    removedText: 'Было',
    addedText: 'Стало',
    noRemovedText: 'Нет удалённых строк.',
    noAddedText: 'Нет добавленных строк.',
    truncatedDiff: 'Показан фрагмент отличий. На странице больше изменённых строк.',
    hiddenDiffs: 'Ещё страниц с отличиями: {count}.',
    clear: 'Сравнить другие PDF',
    tooManyPages:
      'В одном из PDF больше {pages} страниц. Для стабильной локальной обработки выберите документ меньше.',
    noTextLayer:
      'Текстовый слой не найден хотя бы в одном PDF. Скорее всего, это скан или PDF из картинок. Этот инструмент не распознаёт текст на изображениях.',
    encrypted:
      'Один из PDF защищён паролем или зашифрован. Снимите защиту и попробуйте ещё раз.',
    invalidPdf:
      'Не удалось открыть один из PDF. Проверьте, что файлы не повреждены и действительно являются PDF.',
    compareError:
      'Не удалось сравнить эти PDF. Попробуйте другие файлы или уменьшите размер документов.',
  },

  extractPdfImages: {
    scopeTitle: 'Что извлекаем',
    scopeBody:
      'Ищем встроенные растровые изображения внутри PDF через pdf.js. Это не экспорт страниц целиком: текст, векторная графика, сложные маски и исходная компрессия изображения могут не сохраниться.',
    submit: 'Извлечь картинки',
    loading: 'Ищем картинки…',
    progressTitle: 'Читаем PDF',
    progressPages: 'Страница {current} из {total}',
    noImagesTitle: 'Картинки не найдены',
    noImagesBody:
      'Проверили страниц: {pages}. В этом PDF может не быть отдельных встроенных растровых изображений: страницы могут быть текстом, векторной графикой или уже цельными сканами.',
    resultStats: 'Картинок: {images} · страниц проверено: {pages} · общий размер: {size}',
    imageMeta: 'Стр. {page} · {width}×{height}px · {size}',
    previewAlt: 'Извлечённая картинка {index}',
    downloadOne: 'Скачать PNG',
    downloadZip: 'Скачать ZIP',
    clear: 'Выбрать другой PDF',
    truncated:
      'Показаны первые найденные изображения. В PDF слишком много объектов, поэтому часть мелких картинок могла быть пропущена.',
    encrypted:
      'PDF защищён паролем или зашифрован. Снимите защиту и попробуйте ещё раз.',
    browserMemory:
      'Браузеру не хватило памяти для извлечения картинок. Попробуйте файл меньше или закройте лишние вкладки.',
    extractError:
      'Не удалось извлечь картинки из этого PDF. Файл может быть повреждён или использовать неподдержанную структуру изображений.',
  },

  flattenPdf: {
    scopeTitle: 'Что поддерживается',
    scopeBody:
      'Инструмент фиксирует стандартные поля формы (AcroForm). Обычные комментарии, выделения, штампы, рукописные пометки и XFA-only формы могут остаться без изменений.',
    submit: 'Зафиксировать поля',
    loading: 'Фиксируем поля…',
    downloadPdf: 'Скачать PDF',
    again: 'Обработать другой PDF',
    totalPages: 'Страниц',
    fieldsFlattened: 'Полей найдено',
    noFieldsNotice:
      'В PDF не найдено стандартных AcroForm-полей. Файл сохранён заново, но видимых изменений может не быть.',
    xfaNotice:
      'В PDF есть XFA-данные. Инструмент фиксирует только стандартные AcroForm-поля; XFA-only поведение может отличаться в разных просмотрщиках.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось зафиксировать поля PDF. Файл может быть повреждён или использовать неподдержанные поля.',
  },

  fillPdfForm: {
    pick: 'Выберите PDF с интерактивной формой',
    limit: 'PDF до 32 МБ, 200 страниц и 500 полей',
    local: 'Обрабатывается локально в браузере',
    scopeTitle: 'Только существующие поля формы',
    scope:
      'Поддерживаем AcroForm: текст, флажки, радиокнопки, выпадающие и обычные/множественные списки. Внешний вид текста рассчитан на латиницу, кириллицу и распространённые символы; отсутствующие в шрифте знаки отклоняются.',
    inspecting: 'Проверяем структуру и ищем поля…',
    summary: 'Страниц: {pages} · полей: {fields}',
    changeFile: 'Другой PDF',
    flatten: 'Зафиксировать поля после заполнения',
    flattenHint: 'Значения останутся видимыми, но поля нельзя будет редактировать.',
    download: 'Заполнить и скачать PDF',
    saving: 'Готовим копию…',
    again: 'Выбрать другой PDF',
    types: {
      text: 'Текстовое поле',
      checkbox: 'Флажок',
      radio: 'Радиокнопка',
      dropdown: 'Выпадающий список',
      'option-list': 'Список с выбором',
    },
    errors: {
      'invalid-pdf': 'Файл повреждён, имеет неверный формат или не является PDF.',
      encrypted: 'PDF защищён паролем. Сначала снимите защиту.',
      xfa: 'Это XFA-форма. Инструмент работает только со стандартными AcroForm-полями.',
      'no-fields':
        'Интерактивные поля не найдены. Сканы и обычный текст PDF нельзя заполнить этим инструментом.',
      'unsupported-field': 'В форме найден неподдерживаемый тип поля.',
      'unsupported-glyph':
        'В значении или варианте есть символ, которого нет во встроенном шрифте. Используйте латиницу, кириллицу и распространённые символы.',
      limit: 'PDF превышает безопасные лимиты размера, страниц, объектов, полей или вариантов.',
      processing: 'Не удалось сохранить заполненную копию. Исходный файл не отправлялся на сервер.',
    },
  },

  pdfMetadata: {
    scopeBody:
      'Изменить можно название, автора, тему, ключевые слова и даты. Нестандартные поля и XMP-пакет остаются в файле без изменений.',
    titleLabel: 'Название',
    authorLabel: 'Автор',
    subjectLabel: 'Тема',
    keywordsLabel: 'Ключевые слова',
    creatorLabel: 'Создано в',
    producerLabel: 'PDF записан в',
    summaryTitle: 'В файле страниц: {pages}',
    summaryEmpty: 'Название и автор не указаны, сведения о программе отсутствуют.',
    keywordsPlaceholder: 'договор, счет, архив',
    creationDateLabel: 'Дата создания',
    modificationDateLabel: 'Дата изменения',
    emptyPlaceholder: 'Пусто',
    unsupportedTitle: 'Неподдержанные метаданные',
    unsupportedBody:
      'В PDF есть поля за пределами поддержанного набора. Мы оставим их в файле, но не редактируем через эту форму.',
    unsupportedResultNotice:
      'В файле были неподдержанные метаданные. Они сохранены как есть, но не синхронизированы с изменениями формы.',
    loading: 'Читаем метаданные…',
    saving: 'Сохраняем PDF…',
    save: 'Сохранить PDF',
    downloadPdf: 'Скачать PDF с метаданными',
    again: 'Обработать другой PDF',
    totalPages: 'Страниц',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    invalidDate: 'Одна из дат указана в неверном формате. Очистите поле или выберите дату заново.',
    parseError:
      'Не удалось прочитать или сохранить метаданные PDF. Файл может быть повреждён или использовать неподдержанную структуру.',
  },

  unlockPdf: {
    knownPasswordNotice:
      'Инструмент работает только когда пароль известен вам. Мы не взламываем PDF и не восстанавливаем забытые пароли.',
    passwordLabel: 'Известный пароль открытия PDF',
    passwordPlaceholder: 'Введите пароль',
    submit: 'Снять пароль',
    loading: 'Снимаем пароль…',
    downloadPdf: 'Скачать PDF без пароля',
    clear: 'Выбрать другой PDF',
    successDetails: 'PDF готов, размер файла: {size}.',
    resultNotice:
      'Проверьте скачанный файл в обычном просмотрщике PDF: он должен открываться без запроса пароля.',
    wrongPassword: 'Пароль не подошёл. Проверьте раскладку, регистр и попробуйте ещё раз.',
    unsupportedEncryption:
      'Этот тип шифрования PDF пока не поддерживается браузерной обработкой. Мы не отправляем файл на сервер.',
    invalidPdf: 'Не удалось открыть PDF. Проверьте, что файл не повреждён и действительно является PDF.',
    isolationRequired:
      'Браузер не разрешил безопасный WebAssembly-режим для локальной расшифровки. Обновите браузер или откройте страницу напрямую.',
    decryptError: 'Не удалось снять пароль с этого PDF. Проверьте файл и пароль, затем попробуйте ещё раз.',
  },

  repairPdf: {
    scopeTitle: 'Что реально восстанавливает инструмент',
    scopeBody:
      'Локально запускаем QPDF/WASM и переписываем структуру PDF: cross-reference table/stream, trailer и служебные объекты, которые QPDF смог прочитать эвристически. Это не восстанавливает обрезанные страницы, испорченные изображения, неизвестные пароли или потерянный контент.',
    submit: 'Восстановить PDF',
    loading: 'Проверяем и переписываем PDF…',
    downloadPdf: 'Скачать восстановленный PDF',
    clear: 'Выбрать другой PDF',
    successDetails: 'Файл переписан локально: было {before}, стало {after}.',
    resultNotice:
      'Откройте скачанный файл в обычном PDF-просмотрщике. Если страницы по-прежнему не открываются, повреждение глубже поддержанного структурного repair.',
    encrypted: 'PDF защищён паролем или зашифрован. Сначала снимите защиту, затем попробуйте восстановление.',
    invalidPdf:
      'Не удалось распознать файл как PDF. Проверьте расширение и попробуйте исходный документ без обрезки или повторной загрузки.',
    unrecoverable:
      'QPDF не смог восстановить этот PDF. Частая причина — файл обрезан, отсутствуют важные объекты или повреждены stream-данные страниц.',
    browserRuntime:
      'Браузер не смог запустить локальный QPDF/WASM. Обновите браузер, откройте страницу напрямую или попробуйте файл меньше.',
    repairError:
      'Не удалось восстановить PDF. Файл может использовать повреждение или структуру, которую инструмент не поддерживает.',
  },


  umbrella: {
    h1: 'PDF конвертер онлайн — бесплатно, без регистрации',
    sub: 'Конвертируйте таблицы Excel, HTML и картинки в PDF, переводите PDF в JPG, PNG и текст. Всё работает в браузере, без регистрации и водяных знаков.',
    breadcrumb: 'PDF конвертер',
    schemaName: 'pdfy.ru — PDF конвертер',
    toolsHeading: 'Все инструменты',
    longFormHeading: 'Как выбрать нужный формат',
    para1: 'PDF — универсальный формат для отправки и печати: сохраняет вёрстку на любом устройстве и не позволяет случайно изменить содержимое. Здесь можно собрать PDF из таблицы, HTML или фотографий и достать из PDF картинки или текст.',
    para2: 'Для таблиц выберите «Excel в PDF»: листы становятся страницами, текст и числа переносятся без цветов и объединённых ячеек. Документы Word и презентации PowerPoint мы не конвертируем: сохраните их в PDF в самом редакторе, а затем при необходимости сожмите файл.',
    para3: 'Для задач без конвертации: сжатие PDF уменьшает размер файла для отправки по почте, поворот исправляет ориентацию сканов, а экспорт в JPG позволяет вставить страницу PDF как картинку в презентацию или документ. Все инструменты работают прямо в браузере — файл на сервер не уходит.',
    faqHeading: 'Частые вопросы',
    faq: [
      {
        q: 'Бесплатно ли?',
        a: 'Да, все инструменты полностью бесплатны. Без подписок, пробных периодов и скрытых платежей.',
      },
      {
        q: 'Нужна ли регистрация?',
        a: 'Нет. Никаких аккаунтов, email-адресов и паролей — просто выберите файл и получите результат.',
      },
      {
        q: 'Безопасно ли выбирать файлы?',
        a: 'Да. Все инструменты работают прямо в браузере: файл не уходит на сервер и нигде не хранится.',
      },
      {
        q: 'Какие форматы поддерживаются?',
        a: 'На входе: PDF, XLSX, XLS, ODS, HTML, JPG, PNG и HEIC. На выходе: PDF, JPG, PNG и TXT. Word и PowerPoint не поддерживаются.',
      },
      {
        q: 'Есть ли ограничение на размер файла?',
        a: 'Большинство инструментов принимают файлы до 50–100 МБ. Этого достаточно для типичных документов.',
      },
      {
        q: 'Будут ли водяные знаки на готовом файле?',
        a: 'Нет. Никаких водяных знаков, логотипов и вставок «обработано на pdfy.ru».',
      },
    ],
  },

  utilities: {
    'pdf-viewer': {
      title: 'Открыть PDF онлайн',
      shortDescription: 'Просмотрите страницы PDF локально в браузере без загрузки файла на сервер.',
      longDescription: 'Откройте PDF прямо в браузере, переходите между страницами, меняйте масштаб и смотрите основные сведения о документе.',
      marketing: [
        'Быстрый локальный просмотр помогает проверить документ перед печатью, отправкой или дальнейшей обработкой без установки отдельной программы.',
        'Байты PDF передаются pdf.js только в браузере и не загружаются на сервер pdfy. После просмотра можно перейти к повороту, разделению, сжатию, извлечению текста или конвертации страниц.',
      ],
      faq: [
        { q: 'PDF отправляется на сервер?', a: 'Нет. Файл читается и страницы рендерятся локально через pdf.js. В DevTools → Network не будет запроса с байтами PDF.' },
        { q: 'Можно открыть PDF с паролем?', a: 'Нет. Зашифрованные и защищённые паролем PDF отклоняются. Сначала снимите защиту отдельным инструментом, если у вас есть пароль.' },
        { q: 'Можно редактировать или комментировать PDF?', a: 'Нет. Эта страница предназначена только для просмотра. Для отдельных действий используйте ссылки на поворот, разделение, сжатие и другие PDF-инструменты.' },
        { q: 'Какие ограничения у просмотра?', a: 'Один PDF до 32 МБ и 400 страниц. Слишком сложная структура или большие страницы отклоняются до опасного выделения памяти.' },
        { q: 'Работают ли сканированные PDF?', a: 'Да, если страницы корректно отображаются в PDF. OCR не выполняется: текст на скане не станет выделяемым.' },
      ],
      howTo: [
        { name: 'Выберите PDF', text: 'Нажмите на область загрузки или перетащите один PDF-файл.' },
        { name: 'Дождитесь открытия', text: 'pdf.js локально проверит документ и определит количество страниц.' },
        { name: 'Просматривайте страницы', text: 'Используйте кнопки назад и вперёд, режим вписывания и масштаб.' },
        { name: 'Выберите следующее действие', text: 'При необходимости перейдите к повороту, разделению, сжатию или конвертации PDF.' },
      ],
    },
    'document-scanner': {
      title: 'Сканер документов онлайн',
      shortDescription: 'Обрежьте и улучшите фото страниц, затем скачайте один PDF.',
      longDescription: 'Превратите фотографии JPG, PNG и WebP в аккуратный многостраничный PDF: обрежьте края, поверните и настройте вид каждой страницы.',
      marketing: [
        'Это не простая сборка JPG в PDF: перед экспортом можно обрезать края каждого фото, повернуть его, выбрать цветной, серый или чёрно-белый вид.',
        'Файлы последовательно обрабатываются в фоновом потоке браузера и не отправляются на сервер.',
      ],
      faq: [
        { q: 'Фотографии загружаются на сервер?', a: 'Нет. Декодирование, обрезка, фильтры и сборка PDF выполняются локально в браузере.' },
        { q: 'Чем этот инструмент отличается от JPG в PDF?', a: 'JPG в PDF объединяет исходные картинки. Сканер сначала позволяет обрезать, повернуть и улучшить каждую страницу.' },
        { q: 'Появится ли в PDF текстовый слой?', a: 'Нет. Текст не распознаётся: результат состоит из изображений.' },
        { q: 'Это заверенный скан?', a: 'Нет. Инструмент только очищает фото и собирает PDF; он не подтверждает подлинность или соответствие чьим-либо требованиям.' },
      ],
      howTo: [
        { name: 'Добавьте фото страниц', text: 'Выберите несколько JPG, PNG или WebP либо сфотографируйте страницу камерой.' },
        { name: 'Подготовьте каждую страницу', text: 'Обрежьте края, поверните фото и настройте цвет, яркость и контраст.' },
        { name: 'Задайте порядок', text: 'Переместите страницы вверх или вниз; в таком же порядке они попадут в PDF.' },
        { name: 'Скачайте PDF', text: 'Нажмите «Собрать скан в PDF». Обработка идёт локально и последовательно.' },
      ],
    },
    'sign-pdf': {
      title: 'Подписать PDF',
      shortDescription: 'Поставьте визуальную подпись на выбранные страницы PDF локально.',
      longDescription: 'Создайте подпись текстом, нарисуйте её пальцем или мышью либо загрузите PNG/JPG, разместите и измените размер прямо на страницах. Это визуальный штамп, не КЭП и не сертификатная подпись.',
      marketing: ['PDF обрабатывается локально в браузере и не отправляется на сервер.', 'Одна созданная подпись может быть размещена на одной или нескольких выбранных страницах.'],
      faq: [
        { q: 'Это квалифицированная электронная подпись?', a: 'Нет. Инструмент добавляет только видимое изображение подписи. Он не создаёт сертификат, КЭП, audit trail и не подтверждает личность.' },
        { q: 'PDF отправляется на сервер?', a: 'Нет. Просмотр и добавление подписи выполняются локально в браузере.' },
        { q: 'Как создать подпись?', a: 'Её можно напечатать, нарисовать мышью или пальцем либо загрузить PNG/JPG. Прозрачность PNG сохраняется.' },
        { q: 'Можно подписать несколько страниц?', a: 'Да. Отметьте нужные страницы, настройте положение и размер подписи и скачайте результат.' },
      ],
      howTo: [
        { name: 'Загрузите PDF', text: 'Выберите один PDF-файл; он останется в браузере.' },
        { name: 'Создайте подпись', text: 'Напечатайте, нарисуйте или загрузите изображение подписи.' },
        { name: 'Выберите страницы', text: 'Отметьте страницы, на которых должна появиться подпись.' },
        { name: 'Разместите подпись', text: 'Перетащите подпись и измените её размер на предпросмотре.' },
        { name: 'Скачайте PDF', text: 'Добавьте визуальную подпись и скачайте готовый файл.' },
      ],
    },
    szhat: {
      title: 'Сжать PDF до нужного размера',
      shortDescription: 'Сожмите PDF локально или выберите ориентир 5 МБ и проверьте результат.',
      longDescription:
        'Сжимаем PDF локально и проверяем результат по ориентиру 5 МБ. Файл не покидает браузер.',
      marketing: [
        'Уменьшите размер PDF с выбранным балансом качества для отправки по почте, загрузки на портал или хранения на устройстве.',
        'Файл обрабатывается локально, в вашем браузере — не загружается на сервер. Сжимаются изображения внутри PDF: JPEG и обычные растровые картинки. Текст и векторная графика остаются как есть.',
        'Если нужен файл не больше 5 МБ, выберите целевой режим. Это ориентир, а не гарантия: после обработки инструмент честно покажет, достигнут размер или нет.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF сжимается прямо в вашем браузере и никуда не уходит.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Большинство офисных PDF значительно меньше этого порога.',
        },
        {
          q: 'Какое качество после сжатия?',
          a: 'Вы сами выбираете уровень: минимальное (практически без потерь), стандартное (баланс размера и качества) или сильное (заметное уменьшение, качество снижается). Для большинства документов подходит стандартный уровень.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет. Инструмент полностью бесплатен, регистрация не требуется.',
        },
        {
          q: 'Что если файл не сжался или стал больше?',
          a: 'Если PDF не содержит растровых изображений (например, чисто текстовый документ), сжатие даёт минимальный эффект. В этом случае инструмент сообщит об этом и предложит скачать файл как есть.',
        },
        {
          q: 'Работает ли сжатие для защищённых паролем PDF?',
          a: 'Нет. PDF с паролем нельзя обработать без снятия защиты. Сначала уберите пароль, затем сжимайте.',
        },
        {
          q: 'Как проверить, что файл не уходит на сервер?',
          a: 'Откройте DevTools (F12) → вкладку Network, загрузите файл и нажмите «Сжать». При локальной обработке вы не увидите сетевых запросов с вашим файлом.',
        },
        {
          q: 'Можно ли гарантированно сжать любой PDF до 5 МБ?',
          a: 'Нет. Итоговый размер зависит от структуры документа: растровые изображения обычно сжимаются хорошо, а текстовые, векторные или уже оптимизированные PDF могут почти не уменьшиться. Инструмент показывает фактический результат без гарантии.',
        },
        {
          q: 'Как я пойму, что файл уложился в 5 МБ?',
          a: 'Выберите ориентир 5 МБ. После обработки страница покажет исходный размер, итоговый размер и отдельный статус: достигнут выбранный размер или нет.',
        },
        {
          q: 'Что делать, если файл всё ещё больше 5 МБ?',
          a: 'Попробуйте сильное сжатие. Если этого недостаточно, уменьшите исходные изображения, удалите лишние страницы или экспортируйте документ заново с меньшим качеством картинок.',
        },
      ],
      howTo: [
        {
          name: 'Выберите файл',
          text: 'Нажмите на область загрузки или перетащите PDF-файл прямо в браузер.',
        },
        {
          name: 'Выберите уровень сжатия',
          text: 'Выберите обычное сжатие или ориентир 5 МБ, затем задайте «Стандартное», «Сильное» или «Минимальное» качество.',
        },
        {
          name: 'Нажмите «Сжать PDF»',
          text: 'Файл обрабатывается в браузере — никакой загрузки не происходит.',
        },
        {
          name: 'Скачайте результат',
          text: 'Когда сжатие завершится, вы увидите исходный и новый размер, а для целевого режима — достигнут ли ориентир 5 МБ. Скачайте готовый файл одним кликом.',
        },
      ],
    },
    vJpg: {
      title: 'PDF в JPG',
      shortDescription:
        'Каждая страница PDF — отдельное изображение JPG. Локально в браузере.',
      longDescription:
        'Рендерим PDF в JPG прямо в браузере через pdf.js. Можно выбрать DPI (72/150/300), многостраничные документы собираются в ZIP. Файл не уходит на сервер.',
      marketing: [
        'Извлеките страницы PDF в формате JPG с нужным разрешением. Удобно для публикации в социальных сетях, вставки в презентации или отправки скриншотов документа.',
        'Файл обрабатывается локально, в вашем браузере — ничего не загружается на сервер. Многостраничные документы автоматически собираются в ZIP.',
      ],
      faq: [
        {
          q: 'Файл уходит на сервер?',
          a: 'Нет. PDF рендерится прямо в вашем браузере через pdf.js. Проверить это можно в DevTools → Network: никаких запросов с файлом не будет.',
        },
        {
          q: 'Какое качество изображений?',
          a: 'Можно выбрать DPI: 72 (для веба и соцсетей), 150 (универсальное) или 300 (печатное качество). Более высокий DPI даёт чёткое изображение, но увеличивает размер файла и время обработки.',
        },
        {
          q: 'Что происходит с многостраничным PDF?',
          a: 'Каждая страница становится отдельным JPG-файлом. Если страниц больше одной — все JPG автоматически упаковываются в ZIP-архив для удобного скачивания.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Для больших документов с высоким DPI рекомендуем выбирать 72 или 150 DPI, чтобы браузер не испытывал нехватку памяти.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет, инструмент бесплатен и не требует регистрации.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите защиту с PDF, затем конвертируйте.',
        },
        {
          q: 'Какое расширение у скачиваемых файлов?',
          a: 'Для одностраничного PDF — один файл .jpg. Для многостраничного — архив .zip со всеми страницами в формате JPG.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл.',
        },
        {
          name: 'Выберите качество (DPI)',
          text: '72 DPI подходит для веба, 150 — универсальный вариант, 300 — для печати.',
        },
        {
          name: 'Нажмите «Конвертировать в JPG»',
          text: 'Браузер рендерит каждую страницу PDF в JPG локально, без отправки на сервер.',
        },
        {
          name: 'Скачайте изображения',
          text: 'Для одной страницы — один JPG. Для нескольких страниц — ZIP-архив с отдельным JPG для каждой страницы.',
        },
      ],
    },
    'pdf-to-png': {
      title: 'PDF в PNG',
      shortDescription:
        'Каждая страница PDF — отдельный PNG. Локально в браузере.',
      longDescription:
        'Рендерим PDF в PNG прямо в браузере через pdf.js. Можно выбрать разрешение DPI, многостраничные документы собираются в ZIP. Файл не уходит на сервер.',
      marketing: [
        'Экспортируйте страницы PDF в PNG, когда нужен формат без JPEG-сжатия: для скриншотов интерфейсов, схем, документов с мелким текстом или прозрачных workflow, где важна чёткость линий.',
        'PDF обрабатывается локально в вашем браузере через pdf.js. Одна страница скачивается как PNG, несколько страниц автоматически упаковываются в ZIP-архив.',
      ],
      faq: [
        {
          q: 'Файл уходит на сервер?',
          a: 'Нет. PDF рендерится прямо в вашем браузере через pdf.js. Проверить это можно в DevTools → Network: запросов с вашим PDF не будет.',
        },
        {
          q: 'Чем PNG отличается от JPG?',
          a: 'PNG сохраняет изображение без JPEG-сжатия и лучше подходит для текста, схем, скриншотов и резких линий. Обычно PNG-файлы крупнее JPG.',
        },
        {
          q: 'Есть ли настройка качества?',
          a: 'Нет отдельного JPEG-quality, потому что PNG не использует потери качества такого типа. Можно выбрать DPI: 72, 150 или 300 — это управляет разрешением итоговых страниц.',
        },
        {
          q: 'Что происходит с многостраничным PDF?',
          a: 'Каждая страница становится отдельным PNG-файлом. Если страниц больше одной — все PNG автоматически упаковываются в ZIP-архив.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Для больших документов рекомендуем 72 или 150 DPI, чтобы браузеру хватило памяти.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите защиту с PDF, затем конвертируйте.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл.',
        },
        {
          name: 'Выберите разрешение',
          text: '72 DPI подходит для быстрых превью, 150 — для большинства задач, 300 — для крупного вывода.',
        },
        {
          name: 'Нажмите «Конвертировать в PNG»',
          text: 'Браузер локально отрендерит каждую страницу PDF в PNG без отправки файла на сервер.',
        },
        {
          name: 'Скачайте PNG',
          text: 'Для одной страницы скачивается PNG-файл. Для нескольких страниц — ZIP-архив с PNG по каждой странице.',
        },
      ],
    },
    jpgVPdf: {
      title: 'JPG в PDF',
      shortDescription:
        'Соберите JPG и PNG изображения в один PDF локально в браузере.',
      longDescription:
        'Объединяем JPG и PNG в один PDF прямо в браузере через pdf-lib. Можно добавить несколько изображений, поменять порядок и скачать готовый PDF без загрузки файлов на сервер.',
      marketing: [
        'Соберите фотографии, сканы или картинки в один PDF для отправки по почте, загрузки на портал или печати. Каждое изображение становится отдельной страницей PDF.',
        'Файлы обрабатываются локально, в вашем браузере. Изображения не отправляются на сервер, на результат не добавляются водяные знаки.',
      ],
      faq: [
        {
          q: 'Файлы отправляются на сервер?',
          a: 'Нет. JPG и PNG собираются в PDF прямо в браузере через pdf-lib. Проверить это можно в DevTools → Network: сетевых запросов с вашими изображениями не будет.',
        },
        {
          q: 'Какие форматы поддерживаются?',
          a: 'JPG, JPEG и PNG. HEIC, WebP, TIFF и OCR не входят в первый релиз и могут появиться отдельными задачами.',
        },
        {
          q: 'Можно ли менять порядок страниц?',
          a: 'Да. После добавления файлов используйте стрелки вверх и вниз — порядок изображений в списке станет порядком страниц в PDF.',
        },
        {
          q: 'Какой максимальный размер файлов?',
          a: 'Суммарно до 50 МБ. Это ограничение защищает браузер от нехватки памяти на больших изображениях.',
        },
        {
          q: 'Будет ли водяной знак?',
          a: 'Нет. PDF создаётся без логотипов, подписей и водяных знаков.',
        },
      ],
      howTo: [
        {
          name: 'Добавьте изображения',
          text: 'Перетащите JPG или PNG в область загрузки либо выберите файлы через кнопку.',
        },
        {
          name: 'Проверьте порядок',
          text: 'Используйте стрелки вверх и вниз, чтобы расположить изображения в нужном порядке.',
        },
        {
          name: 'Нажмите «Собрать PDF»',
          text: 'Браузер создаст PDF локально, без отправки изображений на сервер.',
        },
        {
          name: 'Скачайте PDF',
          text: 'Готовый документ содержит одну страницу на каждое изображение в выбранном порядке.',
        },
      ],
    },
    'png-v-pdf': {
      title: 'PNG в PDF',
      shortDescription:
        'Соберите PNG изображения в один PDF локально в браузере.',
      longDescription:
        'Объединяем PNG в один PDF прямо в браузере через pdf-lib. Можно добавить несколько изображений, поменять порядок и скачать готовый PDF без загрузки файлов на сервер. JPG поддерживается как дополнительный формат.',
      marketing: [
        'Соберите PNG-скриншоты, прозрачные изображения или отсканированные страницы в один PDF для отправки, печати или загрузки на сайт. Каждая картинка становится отдельной страницей PDF.',
        'Файлы обрабатываются локально, в вашем браузере. PNG и JPG не отправляются на сервер, а на результат не добавляются водяные знаки.',
      ],
      faq: [
        {
          q: 'Файлы отправляются на сервер?',
          a: 'Нет. PNG и JPG собираются в PDF прямо в браузере через pdf-lib. Проверить это можно в DevTools → Network: сетевых запросов с вашими изображениями не будет.',
        },
        {
          q: 'Какие форматы поддерживаются?',
          a: 'Основной формат страницы — PNG. Дополнительно можно добавить JPG и JPEG, если нужно собрать смешанный PDF.',
        },
        {
          q: 'Сохраняется ли прозрачность PNG?',
          a: 'PNG встраивается как изображение на страницу PDF. Визуальный результат сохраняется, но итоговый PDF предназначен для просмотра и печати, а не для дальнейшего редактирования слоёв.',
        },
        {
          q: 'Можно ли менять порядок страниц?',
          a: 'Да. После добавления файлов используйте стрелки вверх и вниз — порядок изображений в списке станет порядком страниц в PDF.',
        },
        {
          q: 'Какой максимальный размер файлов?',
          a: 'Суммарно до 50 МБ. Это ограничение защищает браузер от нехватки памяти на больших изображениях.',
        },
      ],
      howTo: [
        {
          name: 'Добавьте PNG',
          text: 'Перетащите PNG в область загрузки либо выберите файлы через кнопку. При необходимости можно добавить JPG.',
        },
        {
          name: 'Проверьте порядок',
          text: 'Используйте стрелки вверх и вниз, чтобы расположить изображения в нужном порядке.',
        },
        {
          name: 'Нажмите «Собрать PDF»',
          text: 'Браузер создаст PDF локально, без отправки изображений на сервер.',
        },
        {
          name: 'Скачайте PDF',
          text: 'Готовый документ содержит одну страницу на каждое изображение в выбранном порядке.',
        },
      ],
    },
    heicVPdf: {
      title: 'HEIC в PDF',
      shortDescription:
        'Конвертируйте HEIC и HEIF фотографии в PDF локально в браузере.',
      longDescription:
        'HEIC/HEIF фотографии декодируются в браузере через WASM-библиотеку heic2any, затем собираются в PDF через pdf-lib. Файлы не отправляются на сервер.',
      marketing: [
        'Инструмент подходит для фотографий с iPhone и других устройств, которые сохраняют снимки в HEIC или HEIF. Каждая фотография становится отдельной страницей PDF.',
        'HEIC-декодер загружается только на этой странице и только при конвертации. JPG/PNG-инструмент остаётся лёгким, а HEIC-файлы обрабатываются локально без водяных знаков.',
      ],
      faq: [
        {
          q: 'Файлы отправляются на сервер?',
          a: 'Нет. HEIC/HEIF декодируются в браузере через WebAssembly, затем PDF создаётся локально через pdf-lib. Файлы не загружаются на сервер.',
        },
        {
          q: 'Какие браузеры поддерживаются?',
          a: 'Нужен современный браузер с WebAssembly и Web Workers: актуальные Chrome, Safari, Firefox или Edge. Нативный просмотр HEIC есть не везде, поэтому инструмент использует отдельный локальный декодер.',
        },
        {
          q: 'Почему это отдельная страница, а не JPG в PDF?',
          a: 'HEIC требует отдельного декодера и других ошибок совместимости. Отдельная страница честнее для SEO и не утяжеляет обычный JPG/PNG-инструмент.',
        },
        {
          q: 'Сохраняются ли EXIF и геоданные?',
          a: 'Нет. Для PDF используется только изображение; метаданные HEIC не переносятся в результат.',
        },
        {
          q: 'Какой максимальный размер файлов?',
          a: 'Суммарно до 50 МБ. HEIC-декодирование расходует память браузера, поэтому очень большие серии фотографий лучше конвертировать частями.',
        },
      ],
      howTo: [
        {
          name: 'Добавьте HEIC или HEIF',
          text: 'Перетащите фотографии в область загрузки либо выберите файлы через кнопку.',
        },
        {
          name: 'Проверьте порядок',
          text: 'Используйте стрелки вверх и вниз, чтобы расположить фотографии в нужном порядке.',
        },
        {
          name: 'Нажмите «Собрать PDF»',
          text: 'Браузер локально декодирует HEIC/HEIF в JPEG и создаст PDF без отправки файлов на сервер.',
        },
        {
          name: 'Скачайте PDF',
          text: 'Готовый документ содержит одну страницу на каждую фотографию в выбранном порядке.',
        },
      ],
    },
    htmlToPdf: {
      title: 'HTML в PDF',
      shortDescription:
        'Преобразуйте вставленный HTML или HTML-файл в PDF локально в браузере.',
      longDescription:
        'Рендерим HTML в PDF прямо в браузере прямо на вашем устройстве. Инструмент принимает вставленный код и .html/.htm файлы; ссылки на страницы он не открывает.',
      marketing: [
        'Соберите PDF из готовой HTML-разметки: письма, простые отчёты, инструкции, коммерческие предложения и другие документы можно сохранить как PDF без установки редактора.',
        'Обработка выполняется локально в браузере. HTML не отправляется на сервер; внешние картинки и стили могут загрузиться браузером только если они уже указаны в вашей разметке и доступны публично.',
        'Инструмент не открывает страницы по ссылке: для этого нужен сервер, а здесь всё работает в браузере.',
      ],
      faq: [
        {
          q: 'Можно вставить URL страницы?',
          a: 'Нет, поддерживаются только вставленный HTML и HTML-файлы. Чтобы открыть страницу по ссылке, нужен сервер, а здесь всё работает в браузере.',
        },
        {
          q: 'HTML отправляется на сервер?',
          a: 'Нет. PDF создаётся локально в браузере. Если внутри HTML есть внешние изображения, шрифты или CSS по URL, сам браузер может запросить эти ресурсы у их хостов.',
        },
        {
          q: 'Поддерживается ли CSS?',
          a: 'Да, применяются обычные стили страницы, inline style и встроенные style-теги. Сложная интерактивность и скрипты не являются целью этого инструмента.',
        },
        {
          q: 'Какой максимальный размер HTML?',
          a: 'До 250 000 символов в поле или HTML-файл до 5 МБ. Это ограничение защищает браузер от зависаний при рендере.',
        },
        {
          q: 'Будет ли водяной знак?',
          a: 'Нет. PDF создаётся без логотипов, подписей и водяных знаков.',
        },
      ],
      howTo: [
        {
          name: 'Вставьте HTML или загрузите файл',
          text: 'Вставьте разметку в поле либо выберите .html/.htm файл через переключатель HTML-файла.',
        },
        {
          name: 'Проверьте содержимое',
          text: 'При необходимости поправьте текст, заголовки и inline-стили прямо в поле перед конвертацией.',
        },
        {
          name: 'Нажмите «Создать PDF»',
          text: 'Браузер локально рендерит HTML в страницу A4 и собирает PDF без отправки HTML на сервер.',
        },
        {
          name: 'Скачайте PDF',
          text: 'После генерации скачайте готовый PDF-файл одним кликом.',
        },
      ],
    },
    pdfToText: {
      title: 'PDF в текст',
      shortDescription:
        'Извлеките текстовый слой из PDF в TXT локально в браузере — без OCR.',
      longDescription:
        'Достаём уже существующий текстовый слой PDF через pdf.js прямо в браузере. Результат можно просмотреть и скачать как .txt. Сканированные страницы без OCR не распознаются.',
      marketing: [
        'Получите обычный TXT из PDF-документа с текстовым слоем: удобно для копирования, поиска, черновой обработки и переноса текста в редактор.',
        'Файл обрабатывается локально, в вашем браузере — PDF не загружается на сервер. Инструмент честно не обещает OCR: если документ состоит из сканов или картинок, вы увидите понятное сообщение вместо пустого “успеха”.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается прямо в браузере через pdf.js, файл не загружается на сервер. Проверить это можно в DevTools → Network.',
        },
        {
          q: 'Работает ли инструмент со сканами?',
          a: 'Нет. Инструмент извлекает только существующий текстовый слой. Сканы и картинки он не распознаёт.',
        },
        {
          q: 'Почему результат может быть пустым?',
          a: 'Если PDF выглядит как текст, но внутри это изображение страницы, текстового слоя нет. В таком случае инструмент покажет объяснение про скан/картинку.',
        },
        {
          q: 'Сохраняются ли таблицы и форматирование?',
          a: 'Нет. На выходе простой .txt. Порядок строк зависит от структуры PDF и возможностей pdf.js; сложная вёрстка, колонки и таблицы могут переноситься неидеально.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или шифрование, затем извлекайте текст.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Нажмите «Извлечь текст»',
          text: 'Браузер прочитает текстовый слой локально, без отправки файла на сервер.',
        },
        {
          name: 'Проверьте предпросмотр',
          text: 'Если текста нет или его очень мало, инструмент объяснит, что PDF может быть сканом или картинкой.',
        },
        {
          name: 'Скачайте TXT',
          text: 'Скачайте извлечённый текст как обычный .txt-файл.',
        },
      ],
    },
    'compare-pdf': {
      title: 'Сравнить PDF',
      shortDescription:
        'Сравните два PDF по текстовому слою локально в браузере.',
      longDescription:
        'Сравниваем два PDF постранично по уже существующему текстовому слою: показываем совпавшие, изменённые, добавленные и удалённые страницы. Файлы не отправляются на сервер.',
      marketing: [
        'Инструмент сравнивает текстовый слой PDF. Это быстрый и честный сценарий для договоров, счетов, спецификаций и других документов, где важно понять, что изменилось в тексте.',
        'Файлы читаются локально через pdf.js. Мы не делаем визуальный pixel-diff и не запускаем OCR: такие режимы требуют отдельной проработки качества, производительности и обработки шума от рендера.',
        'Если PDF состоит из сканов или картинок без текстового слоя, инструмент сразу объяснит ограничение. Для больших документов стоит разбить файл или сравнить более короткие версии.',
      ],
      faq: [
        {
          q: 'Как именно сравниваются файлы?',
          a: 'Инструмент извлекает существующий текстовый слой из двух PDF и сравнивает его постранично. Внешний вид страниц не сравнивается, текст на сканах не распознаётся.',
        },
        {
          q: 'Файлы отправляются на сервер?',
          a: 'Нет. Оба PDF читаются прямо в браузере через pdf.js. Проверить это можно в DevTools → Network: запросов с вашими PDF не будет.',
        },
        {
          q: 'Работает ли сравнение со сканами?',
          a: 'Нет. Если PDF состоит из изображений страниц и не содержит текстовый слой, нужен OCR. В таком случае инструмент покажет понятное сообщение.',
        },
        {
          q: 'Что показывает результат?',
          a: 'Сводку по страницам, количество совпавших/изменённых/добавленных/удалённых страниц, разницу по словам и фрагменты строк, которые были удалены или добавлены.',
        },
        {
          q: 'Почему нет визуального сравнения страниц?',
          a: 'Визуальный diff требует рендера страниц в изображения, настройки масштаба и фильтрации шума от шрифтов/антиалиасинга. Для Инструмент выбран более стабильный текстовый режим.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите первый PDF',
          text: 'Выберите исходную версию документа или перетащите её в левую область загрузки.',
        },
        {
          name: 'Загрузите второй PDF',
          text: 'Выберите новую версию документа во второй области загрузки.',
        },
        {
          name: 'Нажмите «Сравнить PDF»',
          text: 'Браузер локально извлечёт текстовый слой из обоих файлов и сравнит страницы.',
        },
        {
          name: 'Проверьте отличия',
          text: 'Посмотрите сводку и фрагменты страниц, где текст был добавлен, удалён или изменён.',
        },
      ],
    },
    'extract-images-from-pdf': {
      title: 'Извлечь картинки из PDF',
      shortDescription:
        'Достаньте встроенные растровые изображения из PDF локально в браузере.',
      longDescription:
        'Ищем image-объекты внутри PDF через pdf.js, показываем найденные картинки и отдаём их как PNG по одной или ZIP-архивом. Файл не отправляется на сервер.',
      marketing: [
        'Этот инструмент нужен, когда из PDF нужно достать сами встроенные картинки: иллюстрации, фото, сканы внутри документа или изображения из презентационного PDF.',
        'Это отличается от «PDF в JPG»: мы не рендерим каждую страницу целиком, а ищем отдельные растровые image-объекты внутри файла. Если в документе только текст, векторная графика или страницы уже склеены в один скан, отдельных картинок может не быть.',
        'Обработка выполняется локально в браузере. PDF не загружается на сервер; найденные изображения пересохраняются в PNG, поэтому исходная компрессия, EXIF и часть сложных масок могут не сохраниться.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается прямо в браузере через pdf.js. Проверить это можно в DevTools → Network: сетевых запросов с вашим PDF не будет.',
        },
        {
          q: 'Чем это отличается от PDF в JPG?',
          a: 'PDF в JPG превращает каждую страницу в картинку. Этот инструмент пытается достать отдельные встроенные изображения из внутренней структуры PDF.',
        },
        {
          q: 'Почему картинки могут не найтись?',
          a: 'В PDF может не быть отдельных image-объектов: документ может состоять из текста, векторных фигур или цельных сканов страниц. Некоторые маски, паттерны и нестандартные image-объекты pdf.js тоже может не отдать как обычную картинку.',
        },
        {
          q: 'В каком формате скачиваются изображения?',
          a: 'Найденные изображения скачиваются как PNG. Для нескольких изображений доступен ZIP-архив.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или шифрование, затем извлекайте картинки.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Нажмите «Извлечь картинки»',
          text: 'Браузер локально прочитает operator list PDF и найдёт raster image-объекты.',
        },
        {
          name: 'Проверьте найденные изображения',
          text: 'Страница покажет превью, страницу источника, размер в пикселях и вес каждого PNG.',
        },
        {
          name: 'Скачайте PNG или ZIP',
          text: 'Скачайте отдельную картинку или весь набор одним ZIP-архивом.',
        },
      ],
    },
    'flatten-pdf': {
      title: 'Зафиксировать поля PDF',
      shortDescription:
        'Сделайте заполненные поля PDF-формы нередактируемыми локально в браузере.',
      longDescription:
        'Инструмент фиксирует поля PDF-формы (AcroForm): видимые значения полей переносятся на страницы, а сами поля становятся недоступны для редактирования. Файл не отправляется на сервер.',
      marketing: [
        'Инструмент подходит для заполненных PDF-анкет, заявлений и договоров, где после заполнения нужно отправить копию без редактируемых полей формы.',
        'Поля фиксируются локально через pdf-lib. Обычные комментарии, выделения, штампы, рукописные пометки и формы только на XFA инструмент не обрабатывает.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается и сохраняется прямо в браузере через pdf-lib. Сетевых запросов с вашим файлом нет.',
        },
        {
          q: 'Что именно фиксируется?',
          a: 'Поддержаны AcroForm-поля: текстовые поля, чекбоксы, радиокнопки и похожие стандартные поля формы. Их видимые значения встраиваются в страницы, а поля перестают быть редактируемыми.',
        },
        {
          q: 'Фиксируются ли комментарии, выделения и штампы?',
          a: 'Не гарантируем. Инструмент надёжно работает с полями формы, а произвольные пометки и рукописные заметки не обрабатывает.',
        },
        {
          q: 'Будет ли PDF превращён в картинки?',
          a: 'Нет. Мы не рендерим каждую страницу в изображение: такой подход ломает поиск по тексту и ухудшает качество. Инструмент сохраняет структуру PDF и фиксирует только поддержанные поля формы.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или шифрование, затем зафиксируйте поля формы.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл с заполненными полями формы или перетащите его в область загрузки.',
        },
        {
          name: 'Проверьте ограничения',
          text: 'Инструмент работает с AcroForm-полями. Комментарии, выделения, штампы и XFA-only формы могут остаться без изменений.',
        },
        {
          name: 'Нажмите «Зафиксировать поля»',
          text: 'Браузер локально встраивает видимые значения полей в страницы и удаляет редактируемые поля формы.',
        },
        {
          name: 'Скачайте результат',
          text: 'Получите новый PDF-файл без загрузки исходника на сервер.',
        },
      ],
    },
    'fill-pdf-form': {
      title: 'Заполнить PDF-форму',
      shortDescription: 'Заполните существующие интерактивные поля PDF локально в браузере.',
      longDescription:
        'Откройте PDF-анкету с полями, заполните текст, флажки, радиокнопки и списки, затем скачайте редактируемую или зафиксированную копию. Файл не отправляется на сервер.',
      marketing: [
        'Инструмент подходит для анкет и заявлений, в которых автор PDF уже создал интерактивные поля. Все значения и сам документ остаются в браузере.',
        'Это не редактор произвольного PDF: мы не добавляем поля поверх обычного текста, не выполняем OCR сканов, не поддерживаем XFA и электронную подпись.',
      ],
      faq: [
        {
          q: 'PDF и введённые данные отправляются на сервер?',
          a: 'Нет. Разбор, заполнение, обновление отображения полей и сохранение выполняются локально в отдельном потоке браузера.',
        },
        {
          q: 'Какие поля поддерживаются?',
          a: 'Текстовые поля, флажки, радиогруппы, выпадающие списки и списки с выбором стандартной AcroForm.',
        },
        {
          q: 'Почему скан или обычный PDF нельзя заполнить?',
          a: 'В них нет интерактивных полей. OCR и добавление произвольного текста не входят в этот инструмент.',
        },
        {
          q: 'Что делает опция «зафиксировать поля»?',
          a: 'Она встраивает видимое значение каждого поля в страницу и удаляет возможность дальнейшего редактирования полей.',
        },
      ],
      howTo: [
        { name: 'Загрузите PDF', text: 'Выберите PDF с существующими интерактивными AcroForm-полями.' },
        { name: 'Проверьте поля', text: 'Инструмент покажет ограниченный список найденных полей и их типы.' },
        { name: 'Заполните форму', text: 'Введите текст и выберите нужные флажки, кнопки и варианты списков.' },
        { name: 'Скачайте копию', text: 'При необходимости зафиксируйте поля и скачайте новый PDF.' },
      ],
    },
    'pdf-metadata': {
      title: 'Посмотреть и изменить метаданные PDF',
      shortDescription:
        'Проверьте автора, название, программу и даты в PDF, затем исправьте их локально.',
      longDescription:
        'Читаем стандартные метаданные PDF в браузере, даём изменить или очистить поддержанные поля и скачать новый PDF без отправки файла на сервер.',
      marketing: [
        'Инструмент полезен, когда PDF нужно подготовить к архиву, публикации или отправке: убрать старого автора, поправить заголовок, тему, ключевые слова или даты документа.',
        'Обработка выполняется локально через pdf-lib. Поддержаны стандартные Info-поля: Title, Author, Subject, Keywords, CreationDate и ModDate.',
        'Нестандартные Info-поля и XMP-пакет PDF показываются честно как неподдержанные для редактирования. Мы не скрываем их наличие и не обещаем синхронизировать XMP с изменениями формы.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается и сохраняется прямо в браузере через pdf-lib. Сетевых запросов с вашим файлом нет.',
        },
        {
          q: 'Какие поля можно изменить?',
          a: 'Title, Author, Subject, Keywords, CreationDate и ModificationDate. Поля можно заполнить, изменить или очистить.',
        },
        {
          q: 'Что будет с XMP и нестандартными полями?',
          a: 'Мы показываем их наличие, но не редактируем. Такие данные остаются в PDF как есть; для полного XMP-редактирования нужен отдельный специализированный инструмент.',
        },
        {
          q: 'Можно ли удалить метаданные?',
          a: 'Да, для поддержанных полей очистите значение и сохраните PDF. Неподдержанные поля не удаляются этой формой.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или шифрование, затем редактируйте метаданные.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Проверьте найденные поля',
          text: 'Страница покажет title, author, subject, keywords, даты и отдельное предупреждение о неподдержанных метаданных.',
        },
        {
          name: 'Измените или очистите значения',
          text: 'Введите новые значения в поддержанные поля. Чтобы удалить поле, оставьте его пустым.',
        },
        {
          name: 'Скачайте новый PDF',
          text: 'Браузер локально пересохранит PDF и отдаст файл с обновлёнными метаданными.',
        },
      ],
    },
    'redact-pdf': {
      title: 'Замазать текст в PDF',
      shortDescription:
        'Закройте фрагменты PDF и скачайте локально пересобранный image-only PDF.',
      longDescription:
        'Выделите области на страницах PDF. Браузер локально растеризует страницы, закрашивает выбранные фрагменты и собирает новый PDF без исходного текстового слоя.',
      marketing: [
        'Это research-gated Инструмент для redaction: мы не просто рисуем прямоугольники поверх исходного PDF, потому что такая накладка оставляет текст внутри файла. Вместо этого страницы превращаются в изображения, области замазываются на пикселях, а затем собирается новый PDF.',
        'Ограничение честное: результат становится image-only документом. Поиск по тексту, выделение текста, ссылки, формы, комментарии и часть векторного качества не сохраняются. Зато исходный content stream не переносится в новый PDF.',
        'Файл обрабатывается локально через pdf.js и pdf-lib, без загрузки на сервер. Это не юридическая гарантия redaction для секретных документов: перед отправкой критичных файлов проверьте результат в отдельном PDF-просмотрщике.',
      ],
      faq: [
        {
          q: 'Это настоящая redaction или только визуальная замазка?',
          a: 'Инструмент пересобирает PDF как изображения: страницы рендерятся в изображения, выбранные зоны закрашиваются на пикселях, исходный текстовый слой и content stream не копируются в результат. Это безопаснее, чем просто нарисовать прямоугольник поверх текста.',
        },
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается, рендерится и пересобирается прямо в браузере через pdf.js и pdf-lib. Проверить можно в DevTools → Network: запросов с вашим PDF не будет.',
        },
        {
          q: 'Почему пропадает выделение текста и ссылки?',
          a: 'Чтобы не оставить скрытый текст под прямоугольниками, инструмент растеризует страницы. Новый PDF состоит из изображений страниц, поэтому текст, ссылки, поля форм и комментарии не сохраняются как редактируемые объекты.',
        },
        {
          q: 'Можно ли считать результат юридически гарантированно безопасным?',
          a: 'Нет. Инструмент не даёт юридической или privacy-гарантии. Для критичных документов проверяйте результат в отдельном просмотрщике и используйте специализированный redaction workflow, если нужен формальный контроль.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или шифрование, затем замазывайте текст.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Выделите зоны',
          text: 'На предпросмотре страниц протяните прямоугольники поверх текста или фрагментов, которые нужно скрыть.',
        },
        {
          name: 'Нажмите «Замазать и пересобрать PDF»',
          text: 'Браузер локально отрендерит страницы, закрасит выбранные пиксели и соберёт новый image-only PDF.',
        },
        {
          name: 'Скачайте и проверьте результат',
          text: 'Откройте новый PDF в отдельном просмотрщике и убедитесь, что нужные зоны скрыты.',
        },
      ],
    },
    unlockPdf: {
      title: 'Снять пароль с PDF',
      shortDescription:
        'Удалить пароль открытия по известному паролю локально в браузере.',
      longDescription:
        'Откройте защищённый PDF с известным паролем и сохраните копию без запроса пароля. Файл обрабатывается локально, без загрузки на сервер.',
      marketing: [
        'Если пароль от PDF известен, но вводить его каждый раз неудобно, сохраните незашифрованную копию для дальнейшей работы.',
        'Инструмент работает только в легитимном сценарии: вы вводите известный пароль. Мы не подбираем, не восстанавливаем и не обходим неизвестные пароли.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF расшифровывается локально в браузере через QPDF/WASM. Проверить это можно в DevTools → Network: файл не загружается на сервер.',
        },
        {
          q: 'Можно ли снять пароль, если я его не знаю?',
          a: 'Нет. pdfy не помогает взламывать PDF, подбирать пароль или обходить защиту. Нужен известный пароль открытия документа.',
        },
        {
          q: 'Что будет при неверном пароле?',
          a: 'Инструмент покажет понятную ошибку и не создаст новый PDF. Попробуйте снова с правильным паролем.',
        },
        {
          q: 'Какие просмотрщики должны открыть результат?',
          a: 'Результат — обычный незашифрованный PDF. Его должны открывать современные браузеры, Adobe Acrobat, Preview на macOS и другие распространённые PDF-просмотрщики.',
        },
        {
          q: 'Есть ли ограничения?',
          a: 'Нужен современный браузер с WebAssembly threads и безопасной изоляцией страницы. Очень старые или нестандартно зашифрованные PDF могут не обработаться.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите защищённый PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Введите известный пароль',
          text: 'Укажите пароль открытия документа. Без известного пароля инструмент не работает.',
        },
        {
          name: 'Нажмите «Снять пароль»',
          text: 'Браузер расшифрует PDF локально и сохранит копию без encryption.',
        },
        {
          name: 'Скачайте результат',
          text: 'Откройте скачанный PDF в обычном просмотрщике и проверьте, что пароль больше не запрашивается.',
        },
      ],
    },
    'repair-pdf': {
      title: 'Восстановить PDF',
      shortDescription:
        'Попробовать исправить структуру PDF локально через QPDF/WASM.',
      longDescription:
        'Инструмент переписывает PDF через QPDF в браузере: помогает при части повреждений xref, trailer и incremental updates, но честно отказывает, если контент потерян или файл нельзя прочитать.',
      marketing: [
        'Repair PDF полезен, когда файл открывается не во всех просмотрщиках, ругается на повреждённую структуру или был некорректно сохранён после передачи.',
        'Файл не уходит на сервер: QPDF запускается локально через WebAssembly и создаёт новую копию PDF с пересобранными служебными таблицами.',
        'Мы не обещаем невозможное: если PDF обрезан при скачивании, зашифрован без пароля, содержит битые изображения или потерял объекты страниц, восстановление может быть невозможно.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Восстановление запускается локально в браузере через QPDF/WASM. Файл не загружается на сервер.',
        },
        {
          q: 'Какие повреждения поддерживаются?',
          a: 'Инструмент покрывает структурные проблемы, которые QPDF умеет прочитать и переписать: часть битых cross-reference таблиц или streams, trailer и лишние/осиротевшие объекты.',
        },
        {
          q: 'Что не получится восстановить?',
          a: 'Обрезанный файл, потерянные страницы, повреждённые stream-данные, неизвестный пароль, вирусные вложения или визуальное качество страниц этот инструмент не чинит.',
        },
        {
          q: 'Почему восстановленный PDF может стать другого размера?',
          a: 'QPDF переписывает внутреннюю структуру файла и удаляет осиротевшие объекты. Размер может стать больше или меньше без прямой связи с качеством восстановления.',
        },
        {
          q: 'Что делать, если восстановление не удалось?',
          a: 'Попробуйте получить исходный PDF заново. Если файл критичен, попробуйте настольные программы для восстановления PDF.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите повреждённый PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Запустите восстановление',
          text: 'Браузер локально запустит QPDF и попробует прочитать документ с включённым recovery.',
        },
        {
          name: 'Скачайте новую копию',
          text: 'Если QPDF смог переписать файл, скачайте восстановленную копию PDF.',
        },
        {
          name: 'Проверьте результат',
          text: 'Откройте PDF в обычном просмотрщике. Если ошибка осталась, повреждение слишком серьёзное для этого инструмента.',
        },
      ],
    },
    excelVPdf: {
      title: 'Excel в PDF',
      shortDescription:
        'Конвертация XLSX, XLS и ODS в PDF прямо в браузере: файл никуда не уходит.',
      longDescription:
        'Переводим таблицы Excel в PDF локально: каждый лист становится одной или несколькими страницами A4 в альбомной ориентации. Файл не покидает браузер.',
      marketing: [
        'Переведите таблицу Excel в PDF для отправки по почте, печати или архивирования. Поддерживаются XLSX, XLS и ODS.',
        'Конвертация идёт прямо в браузере: файл никуда не уходит. Переносятся текст и значения ячеек. Цвета, объединённые ячейки, диаграммы и картинки из таблицы не сохраняются, а страницы PDF получаются изображениями, поэтому текст в них нельзя выделить. Если нужна точная копия вёрстки, сохраните PDF в самом Excel.',
      ],
      faq: [
        {
          q: 'Какие форматы принимаются на вход?',
          a: 'XLSX, XLS и ODS (OpenDocument Spreadsheet). Это охватывает Excel всех версий и LibreOffice Calc.',
        },
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Таблица читается и превращается в PDF прямо в браузере. Проверить это можно в DevTools → Network.',
        },
        {
          q: 'Сохраняется ли оформление таблицы?',
          a: 'Нет. Переносятся значения ячеек и названия листов. Цвета, шрифты, объединённые ячейки и диаграммы не сохраняются. Первая строка каждого листа становится заголовком на всех страницах.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 50 МБ и до 50 000 строк во всей книге. Обработка идёт на вашем устройстве, поэтому большие таблицы конвертируются дольше.',
        },
        {
          q: 'Сохраняются ли формулы?',
          a: 'В PDF попадают значения формул, сохранённые в файле. Живые ссылки и макросы не переносятся — PDF статичен.',
        },
        {
          q: 'Сохраняются ли несколько листов?',
          a: 'Да. Каждый лист получает свои страницы PDF с названием листа сверху.',
        },
        {
          q: 'Поместятся ли широкие таблицы?',
          a: 'Все колонки вписываются в ширину страницы, поэтому в широких таблицах длинные значения обрезаются многоточием. Если колонок больше 12, инструмент предупредит об этом.',
        },
        {
          q: 'Поддерживаются ли защищённые паролем файлы?',
          a: 'Нет. Снимите пароль перед конвертацией.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет, инструмент полностью бесплатен без регистрации и водяных знаков.',
        },
      ],
      howTo: [
        {
          name: 'Выберите файл Excel',
          text: 'Выберите XLSX, XLS или ODS через кнопку или перетащите файл прямо в браузер.',
        },
        {
          name: 'Нажмите «Конвертировать в PDF»',
          text: 'Браузер прочитает таблицу и соберёт PDF на вашем устройстве.',
        },
        {
          name: 'Дождитесь результата',
          text: 'Небольшая таблица конвертируется за секунды, большая — дольше: всё зависит от устройства.',
        },
        {
          name: 'Скачайте PDF',
          text: 'Скачайте готовый PDF одним кликом и проверьте, что важные колонки читаются.',
        },
      ],
    },
    numeraciyaStranic: {
      title: 'Нумерация страниц PDF',
      shortDescription: 'Добавьте номера страниц в PDF: выберите позицию, стартовый номер и страницу начала.',
      longDescription:
        'Добавляем номера страниц в PDF: снизу по центру, снизу справа или сверху справа. Можно задать стартовый номер и выбрать страницу, с которой начинать нумерацию. Всё работает локально в браузере.',
      marketing: [
        'Добавьте номера страниц в PDF-документ. Выберите положение номера: снизу по центру, снизу справа или сверху справа.',
        'Настройте стартовый номер и страницу начала нумерации. Обработка полностью локальная — файл остаётся на вашем устройстве.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Нумерация страниц выполняется прямо в браузере через библиотеку pdf-lib. Файл нигде не хранится и не передаётся.',
        },
        {
          q: 'Какие позиции номера доступны?',
          a: 'Снизу по центру, снизу справа или сверху справа. Позицию можно переключить перед обработкой.',
        },
        {
          q: 'Можно ли начать нумерацию с определённой страницы?',
          a: 'Да. Задайте стартовый номер и физическую страницу, с которой нужно начать. Например, начать со страницы 5 с номера 1.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет, инструмент полностью бесплатен и не требует регистрации.',
        },
        {
          q: 'Меняется ли содержимое PDF?',
          a: 'Только добавляются номера страниц — текст, изображения и вёрстка остаются без изменений.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите защиту паролем, затем добавляйте номера.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл.',
        },
        {
          name: 'Выберите положение номера',
          text: 'Укажите, где показывать номер: снизу по центру, снизу справа или сверху справа.',
        },
        {
          name: 'Настройте нумерацию',
          text: 'Задайте стартовый номер и страницу, с которой начинать нумерацию.',
        },
        {
          name: 'Нажмите «Добавить номера»',
          text: 'Обработка занимает несколько секунд и выполняется прямо в браузере.',
        },
        {
          name: 'Скачайте результат',
          text: 'Готовый PDF с номерами страниц доступен для скачивания.',
        },
      ],
    },
    'watermark-pdf': {
      title: 'Водяной знак в PDF',
      shortDescription: 'Добавьте свой текстовый водяной знак в PDF локально в браузере.',
      longDescription:
        'Наносим ваш текстовый водяной знак на все страницы PDF. Можно настроить текст, прозрачность, позицию и угол. Файл остаётся в браузере и не отправляется на сервер.',
      marketing: [
        'Добавьте в PDF свой текстовый водяной знак: черновик, образец, конфиденциально или любую другую пометку.',
        'Настройки применяются ко всем страницам документа. Обработка полностью локальная — результат формируется в браузере без загрузки файла на сервер.',
      ],
      faq: [
        {
          q: 'Это водяной знак pdfy?',
          a: 'Нет. Инструмент добавляет только тот текст, который вы сами ввели. pdfy не ставит свои логотипы, подписи или ограничения на готовый файл.',
        },
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Водяной знак добавляется прямо в браузере через pdf-lib и canvas. PDF не загружается на сервер и нигде не хранится.',
        },
        {
          q: 'Можно ли использовать русский текст?',
          a: 'Да. Текст сначала рисуется в браузере как изображение, поэтому поддерживаются русские буквы и большинство символов, которые отображает ваш браузер.',
        },
        {
          q: 'На какие страницы добавляется знак?',
          a: 'Водяной знак применяется ко всем страницам PDF.',
        },
        {
          q: 'Какие настройки доступны?',
          a: 'Текст, прозрачность, базовое положение и угол наклона. Для диагонального варианта знак размещается по центру страницы.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите защиту паролем, затем добавляйте водяной знак.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл в браузер.',
        },
        {
          name: 'Введите текст',
          text: 'Укажите текст водяного знака: например «Черновик», «Образец» или название компании.',
        },
        {
          name: 'Настройте вид',
          text: 'Выберите прозрачность, положение и угол. Перед запуском проверьте summary настроек.',
        },
        {
          name: 'Добавьте водяной знак',
          text: 'Нажмите кнопку обработки. Водяной знак будет добавлен на все страницы локально в браузере.',
        },
        {
          name: 'Скачайте результат',
          text: 'Скачайте готовый PDF без регистрации и без дополнительных водяных знаков сервиса.',
        },
      ],
    },
    'protect-pdf': {
      title: 'Поставить пароль на PDF',
      shortDescription: 'Добавьте пароль открытия к PDF локально в браузере — файл не уходит на сервер.',
      longDescription:
        'Защищаем PDF паролем открытия через QPDF в браузере. Пароль нужен для просмотра результата, но это не DRM: не обещаем запрет печати, копирования или обхода владельцем файла.',
      marketing: [
        'Поставьте пароль на PDF перед отправкой по почте, загрузкой в общий чат или передачей документа внешнему получателю. Готовый файл будет запрашивать пароль при открытии.',
        'Обработка выполняется локально в браузере через QPDF WASM. Исходный PDF и пароль не отправляются на сервер, а pdfy не хранит и не может восстановить пароль.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Шифрование выполняется локально в браузере через QPDF WASM. Исходный PDF и пароль не загружаются на сервер.',
        },
        {
          q: 'Можно ли восстановить пароль?',
          a: 'Нет. pdfy не хранит пароль и не сможет восстановить доступ к файлу. Сохраните пароль отдельно перед отправкой документа.',
        },
        {
          q: 'Это защищает от копирования и печати?',
          a: 'Нет. Инструмент ставит пароль открытия. Ограничения на печать, копирование и редактирование не являются надёжной DRM-защитой, поэтому мы их не обещаем.',
        },
        {
          q: 'Какие PDF поддерживаются?',
          a: 'Обычные незашифрованные PDF до 100 МБ. Если файл уже защищён паролем или повреждён, сначала снимите защиту или экспортируйте новый PDF.',
        },
        {
          q: 'Где откроется защищённый PDF?',
          a: 'Результат создаётся QPDF с AES-256 encryption и рассчитан на современные просмотрщики PDF: Acrobat, Chrome/Edge Preview, Preview.app и системные просмотрщики.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Введите пароль',
          text: 'Укажите пароль открытия и повторите его во втором поле, чтобы избежать опечатки.',
        },
        {
          name: 'Нажмите «Поставить пароль»',
          text: 'PDF шифруется локально в браузере. Файл и пароль не отправляются на сервер.',
        },
        {
          name: 'Скачайте результат',
          text: 'Скачайте защищённый PDF и проверьте открытие по паролю в нужном просмотрщике.',
        },
      ],
    },
    deletePdfPages: {
      title: 'Удалить страницы из PDF',
      shortDescription: 'Удалите лишние страницы из PDF по номерам или диапазонам прямо в браузере.',
      longDescription:
        'Удаляем выбранные страницы из PDF локально, без отправки файла на сервер. Укажите одну страницу, несколько номеров или диапазон, а сервис покажет, сколько страниц останется.',
      marketing: [
        'Уберите из PDF лишние страницы: пустые листы, дубли, черновики или ненужные приложения. Можно указать отдельные номера и диапазоны в одном поле.',
        'Обработка выполняется локально через pdf-lib. Файл остаётся в браузере, а результат скачивается как новый PDF без выбранных страниц.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Удаление страниц выполняется прямо в браузере. PDF не загружается на сервер и не хранится у нас.',
        },
        {
          q: 'Как указать страницы для удаления?',
          a: 'Введите номера через запятую: например, 2,5-7 удалит страницу 2 и страницы с 5 по 7 включительно.',
        },
        {
          q: 'Можно ли удалить все страницы?',
          a: 'Нет. В PDF должна остаться хотя бы одна страница, поэтому инструмент заранее покажет ошибку для такого диапазона.',
        },
        {
          q: 'Проверяются ли страницы вне документа?',
          a: 'Да. После загрузки PDF инструмент считает количество страниц и не принимает номера больше длины документа.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Для очень больших документов учитывайте память браузера.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или защиту, затем удаляйте страницы.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите один PDF-файл в браузер.',
        },
        {
          name: 'Укажите страницы',
          text: 'Введите номера страниц для удаления: одна страница, список через запятую или диапазоны вроде 2,5-7.',
        },
        {
          name: 'Проверьте остаток',
          text: 'Инструмент покажет, сколько страниц будет удалено и сколько останется в документе.',
        },
        {
          name: 'Скачайте новый PDF',
          text: 'Нажмите «Удалить страницы» и скачайте готовый файл без выбранных страниц.',
        },
      ],
    },
    'reorder-pdf-pages': {
      title: 'Поменять порядок страниц PDF',
      shortDescription: 'Переставьте страницы PDF в нужном порядке прямо в браузере.',
      longDescription:
        'Организуйте страницы одного PDF локально: загрузите файл, перетащите страницы в нужном порядке и скачайте новый PDF без отправки исходника на сервер.',
      marketing: [
        'Соберите документ в правильной последовательности: перенесите титульный лист, приложения, сканы или подписанные страницы туда, где они должны быть.',
        'Инструмент работает локально через pdf-lib. Исходный PDF остаётся в браузере, а результат создаётся как новый файл с теми же страницами в выбранном порядке.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается и пересобирается прямо в браузере. Проверить это можно во вкладке Network: загрузки исходного файла на сервер не будет.',
        },
        {
          q: 'Как поменять порядок страниц?',
          a: 'После загрузки PDF перетащите плитки страниц мышью или используйте кнопки вверх и вниз на каждой плитке.',
        },
        {
          q: 'Будут ли видны миниатюры страниц?',
          a: 'Инструмент показывает стабильные плитки страниц с исходными номерами. Это быстрее и надёжнее для больших PDF, чем рендерить все страницы в изображения.',
        },
        {
          q: 'Что происходит с качеством PDF?',
          a: 'Страницы копируются в новый PDF без перерендера, поэтому изображения и текст не сжимаются заново.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Для больших документов показывается прогресс пересборки, но скорость всё равно зависит от памяти и мощности браузера.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или защиту, затем меняйте порядок страниц.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Расставьте страницы',
          text: 'Перетащите плитки страниц в нужные места или используйте кнопки вверх и вниз.',
        },
        {
          name: 'Проверьте порядок',
          text: 'Плитки показывают исходный номер страницы и текущую позицию в новом документе.',
        },
        {
          name: 'Скачайте новый PDF',
          text: 'Нажмите «Собрать PDF» и скачайте файл с выбранным порядком страниц.',
        },
      ],
    },
    'n-up-pdf': {
      title: 'Несколько страниц PDF на одном листе',
      shortDescription: 'Разместите 2, 4 или 8 страниц PDF на листе A4 или A3 и скачайте файл для печати.',
      longDescription:
        'Подготовьте PDF к экономной печати: выберите число страниц на листе, формат и ориентацию бумаги, поля, интервалы и порядок заполнения.',
      marketing: [
        'Предпросмотр собирает первые итоговые листы из страниц документа и показывает фактический размер бумаги до экспорта.',
        'Страницы встраиваются в новый PDF как векторные PDF-объекты через pdf-lib, а не превращаются в изображения. Файл остаётся в браузере.',
      ],
      faq: [
        {
          q: 'PDF отправляется на сервер?',
          a: 'Нет. Чтение, предпросмотр и сборка выполняются локально в браузере.',
        },
        {
          q: 'Сохранится ли качество текста и графики?',
          a: 'Да, где это допускает исходный PDF. Страницы встраиваются как векторные объекты без растеризации, поэтому текст и линии остаются резкими.',
        },
        {
          q: 'Какие раскладки доступны?',
          a: '2, 4 или 8 исходных страниц на одном листе A4 или A3, в книжной или альбомной ориентации.',
        },
        {
          q: 'Это режим буклета для двусторонней печати?',
          a: 'Нет. Инструмент раскладывает страницы на листах по строкам или столбцам, но не создаёт тетради и сигнатуры для буклетной печати.',
        },
        {
          q: 'Какие ограничения действуют?',
          a: 'До 100 МБ и до 400 исходных страниц. Ограничения защищают вкладку браузера от нехватки памяти.',
        },
      ],
      howTo: [
        { name: 'Добавьте PDF', text: 'Выберите один PDF-файл — он останется в браузере.' },
        { name: 'Настройте лист', text: 'Выберите 2, 4 или 8 страниц, A4 или A3, ориентацию, поля и интервалы.' },
        { name: 'Проверьте раскладку', text: 'Посмотрите первые итоговые листы, их размеры и порядок заполнения.' },
        { name: 'Скачайте PDF', text: 'Соберите векторный PDF и скачайте готовый к печати файл.' },
      ],
    },
    povernut: {
      title: 'Повернуть PDF',
      shortDescription: 'Поворот страниц PDF на 90°, 180° или 270° прямо в браузере.',
      longDescription:
        'Поворачиваем все страницы или выбранный диапазон. Файл не уходит на сервер — обработка в браузере. Удобно для сканов в неправильной ориентации.',
      marketing: [
        'Исправьте ориентацию страниц в PDF: повернуть на 90°, 180° или 270°. Можно выбрать все страницы или только нужные.',
        'Обработка происходит локально, в вашем браузере — файл не загружается на сервер. Результат скачивается мгновенно.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Поворот выполняется прямо в браузере с помощью библиотеки pdf-lib. Ваш файл нигде не хранится и не передаётся.',
        },
        {
          q: 'На сколько градусов можно повернуть?',
          a: 'На 90°, 180° или 270° по часовой стрелке. Для поворота против часовой стрелки на 90° выберите 270°.',
        },
        {
          q: 'Можно ли повернуть только отдельные страницы?',
          a: 'Да. Выберите «Выбранные страницы» и укажите номера или диапазоны в формате 1,3,5-7. Можно также повернуть все страницы сразу.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 50 МБ.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет, инструмент бесплатен и не требует регистрации.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Снимите защиту перед поворотом.',
        },
        {
          q: 'Сохраняется ли качество после поворота?',
          a: 'Да. Поворот — это метаданные в PDF, а не перерендеринг. Изображения и текст не сжимаются заново, качество остаётся таким же, как в оригинале.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл.',
        },
        {
          name: 'Выберите угол поворота',
          text: 'Укажите угол: 90°, 180° или 270°.',
        },
        {
          name: 'Выберите страницы',
          text: 'Повернуть все страницы или только выбранные (укажите номера в формате 1,3,5-7).',
        },
        {
          name: 'Нажмите «Повернуть PDF»',
          text: 'Обработка происходит мгновенно прямо в браузере.',
        },
        {
          name: 'Скачайте результат',
          text: 'Готовый PDF скачивается одним кликом.',
        },
      ],
    },

    mergePdf: {
      title: 'Объединить PDF',
      shortDescription: 'Соедините несколько PDF-файлов в один прямо в браузере.',
      longDescription:
        'Объединяем несколько PDF-файлов в один документ. Можно менять порядок файлов перед объединением. Файлы не уходят на сервер — обработка в браузере.',
      marketing: [
        'Соберите несколько PDF-файлов в один документ: договоры, сканы, отчёты. Можно перетаскивать файлы для изменения порядка.',
        'Объединение происходит локально, в вашем браузере — файлы не загружаются на сервер. Результат скачивается мгновенно.',
      ],
      faq: [
        {
          q: 'Файлы отправляются на сервер?',
          a: 'Нет. Объединение выполняется прямо в браузере с помощью библиотеки pdf-lib. Ваши файлы нигде не хранятся и не передаются.',
        },
        {
          q: 'Сколько файлов можно объединить?',
          a: 'Ограничение по размеру — до 100 МБ на каждый файл. Количество файлов не ограничено, но учитывайте память браузера при очень больших документах.',
        },
        {
          q: 'Можно ли изменить порядок файлов?',
          a: 'Да. После загрузки файлов вы можете менять их порядок с помощью кнопок со стрелками вверх/вниз.',
        },
        {
          q: 'Сохраняется ли качество страниц?',
          a: 'Да. pdf-lib копирует страницы без пережатия, сохраняя исходное качество всех элементов PDF.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет. Инструмент полностью бесплатен, регистрация не требуется.',
        },
        {
          q: 'Можно ли объединить защищённые паролем PDF?',
          a: 'Нет. PDF с паролем нельзя обработать без снятия защиты. Сначала уберите пароль, затем объединяйте.',
        },
      ],
      howTo: [
        {
          name: 'Выберите файлы',
          text: 'Нажмите на область загрузки или перетащите PDF-файлы прямо в браузер. Можно добавить несколько файлов.',
        },
        {
          name: 'Настройте порядок',
          text: 'Поменяйте порядок файлов с помощью стрелок вверх/вниз, удалите лишние или добавьте ещё.',
        },
        {
          name: 'Объедините и скачайте',
          text: 'Нажмите «Объединить PDF» и скачайте готовый документ.',
        },
      ],
    },

    splitPdf: {
      title: 'Разделить PDF',
      shortDescription: 'Извлеките нужные страницы из PDF в новый файл прямо в браузере.',
      longDescription:
        'Сохраняем выбранные страницы PDF в отдельный документ. Укажите диапазон вроде 1-3, 7, 10-12 — файл не отправляется на сервер.',
      marketing: [
        'Выберите страницы договора, скана или отчёта и сохраните только нужный фрагмент в новый PDF. Порядок страниц сохраняется так, как вы указали в диапазоне.',
        'Разделение происходит локально, в вашем браузере через pdf-lib. Файл не загружается на сервер, не хранится и не получает водяных знаков.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. Разделение PDF выполняется прямо в браузере. Ваш файл не передаётся на сервер и не хранится у нас.',
        },
        {
          q: 'Как указать страницы?',
          a: 'Введите номера и диапазоны через запятую: 1-3, 7, 10-12. Можно указывать страницы в нужном порядке.',
        },
        {
          q: 'Можно ли скачать каждую страницу отдельным файлом?',
          a: 'Инструмент сохраняет выбранные страницы в один новый PDF.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Очень большие документы могут упереться в память браузера.',
        },
        {
          q: 'Нужна ли регистрация?',
          a: 'Нет. Инструмент бесплатный, без регистрации и без водяных знаков.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите защиту паролем, затем извлекайте страницы.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Нажмите на область загрузки или перетащите PDF-файл прямо в браузер.',
        },
        {
          name: 'Укажите страницы',
          text: 'Введите диапазон страниц, например 1-3, 7, 10-12. Инструмент сразу проверит синтаксис и границы документа.',
        },
        {
          name: 'Нажмите «Извлечь страницы»',
          text: 'Выбранные страницы копируются в новый PDF локально, без загрузки файла на сервер.',
        },
        {
          name: 'Скачайте результат',
          text: 'Готовый PDF с выбранными страницами доступен для скачивания одним кликом.',
        },
      ],
    },

    'crop-pdf': {
      title: 'Обрезать PDF',
      shortDescription: 'Обрежьте поля PDF по отступам или визуальной рамкой прямо в браузере.',
      longDescription:
        'Меняем CropBox у всех страниц PDF локально, без загрузки файла на сервер. Можно задать точные отступы в миллиметрах или перетащить рамку предпросмотра.',
      marketing: [
        'Уберите лишние белые поля, следы сканера или служебные края PDF перед отправкой, печатью или публикацией. Настройка применяется ко всем страницам документа.',
        'Обрезка выполняется локально через pdf-lib: содержимое не пережимается, файл не отправляется на сервер, а результат скачивается как новый PDF.',
      ],
      faq: [
        {
          q: 'Файл отправляется на сервер?',
          a: 'Нет. PDF читается и обрезается прямо в браузере. Сетевых запросов с вашим файлом нет.',
        },
        {
          q: 'Что именно меняется в PDF?',
          a: 'Инструмент задаёт CropBox страниц. Это стандартная PDF-рамка видимой области: качество изображений и текста не меняется, потому что страницы не рендерятся заново.',
        },
        {
          q: 'Можно ли обрезать разные страницы по-разному?',
          a: 'В текущей версии одни и те же отступы применяются ко всем страницам. Так инструмент остаётся простым для документов со сканами или одинаковыми полями.',
        },
        {
          q: 'Что если страницы разного размера?',
          a: 'После загрузки показываются размеры первой и минимальной страницы. Если выбранные отступы не помещаются на самой маленькой странице, кнопка обрезки блокируется.',
        },
        {
          q: 'Какой максимальный размер файла?',
          a: 'До 100 МБ. Для очень больших PDF учитывайте память браузера.',
        },
        {
          q: 'Поддерживаются ли PDF с паролем?',
          a: 'Нет. Сначала снимите пароль или защиту, затем обрезайте документ.',
        },
      ],
      howTo: [
        {
          name: 'Загрузите PDF',
          text: 'Выберите один PDF-файл или перетащите его в область загрузки.',
        },
        {
          name: 'Настройте область',
          text: 'Введите отступы сверху, справа, снизу и слева в миллиметрах или перетащите края рамки на предпросмотре.',
        },
        {
          name: 'Проверьте размеры',
          text: 'Инструмент показывает размер первой страницы и минимальной страницы, чтобы отступы подходили ко всему документу.',
        },
        {
          name: 'Скачайте результат',
          text: 'Нажмите «Обрезать PDF» — новый файл создаётся локально в браузере без отправки на сервер.',
        },
      ],
    },

  },

  documentScanner: {
    pickGallery: 'Выбрать фото документов', drop: 'Перетащите JPG, PNG или WebP сюда или нажмите для выбора',
    limits: 'До {pages} страниц, {size} МБ суммарно, {megapixels} МП на фото, до {outputMegapixels} МП в PDF', camera: 'Сфотографировать страницу', localNotice: 'Фото остаются в браузере.',
    pageCount: 'Страниц: {count}', pageTitle: 'Страница {page}', previewAlt: 'Превью страницы {page}', moveUp: 'Поднять страницу {page}', moveDown: 'Опустить страницу {page}', remove: 'Удалить', rotate: 'Повернуть 90°',
    modes: { color: 'Цвет', grayscale: 'Серый', 'black-white': 'Ч/Б' }, brightness: 'Яркость', contrast: 'Контраст', crop: 'Обрезка по видимой странице, %', cropSides: { top: 'Сверху', right: 'Справа', bottom: 'Снизу', left: 'Слева' },
    disclaimer: 'Без OCR и автоматического исправления перспективы. Результат — очищенный PDF, а не заверенный или официальный скан.', export: 'Собрать скан в PDF', processing: 'Обрабатываем страницы…', download: 'Скачать PDF',
    errors: { format: 'Поддерживаются только JPG, PNG и WebP.', page_count: 'Можно добавить не более 20 страниц.', total_size: 'Суммарный размер фото больше 50 МБ.', dimensions: 'Фото больше 36 мегапикселей. Уменьшите его перед загрузкой.', corrupt: 'Не удалось прочитать фото. Файл может быть повреждён.', output_limit: 'Суммарный размер страниц больше лимита 64 МП. Уменьшите фото или удалите страницы.', processing: 'Не удалось собрать PDF. Попробуйте другие фото или актуальный браузер.' },
  },

  szhat: {
    targetLegend: 'Целевой размер',
    targetNone: 'Без целевого размера',
    targetNoneHint: 'Просто уменьшить PDF с выбранным качеством',
    targetFiveMb: 'До 5 МБ',
    targetFiveMbHint: 'Постараемся уложиться и покажем результат',
    targetBestEffort:
      '5 МБ — ориентир, а не гарантия. Результат зависит от структуры PDF и выбранного качества.',
    levelLegend: 'Уровень сжатия',
    levelStrong: 'Сильное',
    levelStrongHint: 'Сильнее жмёт — качество снижается больше',
    levelStandard: 'Стандартное',
    levelStandardHint: 'Баланс размера и качества',
    levelMin: 'Минимальное',
    levelMinHint: 'Минимальное сжатие — ближе к оригиналу',
    submit: 'Сжать PDF',
    loadingLocal: 'Сжимаем локально…',
    again: 'Сжать ещё',
    resultTitle: 'Сжатие завершено',
    sizeBefore: 'До',
    sizeAfter: 'После',
    savings: 'Экономия',
    noopTitle: 'Файл уже компактный',
    noopBody: 'В этом PDF нет изображений, которые можно дополнительно сжать без потери качества. Скачайте файл как есть или выберите другой.',
    noopDownload: 'Скачать как есть',
    classifying: 'Анализируем PDF…',
    classifyError: 'Не удалось прочитать PDF. Файл может быть повреждён: попробуйте другой файл или восстановите этот.',
    encryptedError: 'PDF защищён паролем. Сначала снимите защиту, затем повторите сжатие.',
    wasmError: 'Не удалось сжать PDF в этом браузере. Попробуйте другой уровень сжатия или обновите браузер.',
    retryLocal: 'Повторить',
    chooseAnotherFile: 'Выбрать другой файл',
    targetLimit: 'Лимит',
    targetHitTitle: 'Файл уложился в лимит',
    targetHitBody: 'Итоговый PDF не больше {target}. Можно скачивать и загружать туда, где стоит такой лимит.',
    targetMissTitle: 'Лимит пока не достигнут',
    targetMissBody:
      'Итоговый PDF всё ещё больше {target}. Попробуйте более сильный доступный режим; если он не поможет, уменьшите исходные изображения, удалите лишние страницы или экспортируйте документ заново с меньшим качеством картинок.',
    targetNoopMissBody:
      'Файл больше {target}, но в нём нет изображений, которые можно честно сжать без заметной потери качества. Уменьшите исходник или удалите лишние страницы перед повторной загрузкой.',
    targetTryStronger: 'Попробовать сильное сжатие',
    weakSavingsHint: 'Файл почти не уменьшился: в нём мало изображений, которые можно пережать. Удалите лишние страницы или экспортируйте документ заново с меньшим качеством картинок.',
  },

  vJpg: {
    h1: 'PDF в JPG онлайн',
    intro:
      'Конвертируйте страницы PDF в JPG-картинки. Каждая страница — отдельный файл, многостраничный документ собирается в ZIP. Файл обрабатывается прямо в браузере и не отправляется на сервер.',
    dpiLegend: 'Качество (DPI)',
    dpi72Hint: 'Для веба и соцсетей — быстрее, меньше размер',
    dpi150Hint: 'Универсальное качество для большинства задач',
    dpi300Hint: 'Печатное качество — крупнее файлы',
    openingPdf: 'Открываем PDF…',
    pageOf: 'Страница {current} из {total}',
    largeWarn: 'Документ большой — обработка может занять время. Не закрывайте вкладку.',
    submit: 'Конвертировать в JPG',
    loading: 'Конвертируем…',
    again: 'Конвертировать ещё',
    downloadImage: 'Скачать JPG',
    downloadZip: 'Скачать ZIP',
    previewAlt: 'Превью первой страницы',
    pagesLabel: 'Страниц',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    canvasUnavailable: 'Браузер не поддерживает canvas — обновите его и попробуйте снова.',
    oom:
      'Браузеру не хватило памяти, чтобы отрендерить страницу. Попробуйте меньшее качество (72 или 150 DPI) или PDF поменьше.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
  },

  pdfToPng: {
    h1: 'PDF в PNG онлайн',
    intro:
      'Конвертируйте страницы PDF в PNG-картинки. Каждая страница — отдельный файл, многостраничный документ собирается в ZIP. Файл обрабатывается прямо в браузере и не отправляется на сервер.',
    dpiLegend: 'Разрешение (DPI)',
    dpi72Hint: 'Для быстрых превью и веб-страниц',
    dpi150Hint: 'Чёткий универсальный вариант',
    dpi300Hint: 'Высокое разрешение — крупнее файлы',
    openingPdf: 'Открываем PDF…',
    pageOf: 'Страница {current} из {total}',
    largeWarn: 'Документ большой — обработка может занять время. Не закрывайте вкладку.',
    submit: 'Конвертировать в PNG',
    loading: 'Конвертируем…',
    again: 'Конвертировать ещё',
    downloadImage: 'Скачать PNG',
    downloadZip: 'Скачать ZIP',
    previewAlt: 'Превью первой PNG-страницы',
    pagesLabel: 'Страниц',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    canvasUnavailable: 'Браузер не поддерживает canvas — обновите его и попробуйте снова.',
    oom:
      'Браузеру не хватило памяти, чтобы отрендерить страницу. Попробуйте меньшее разрешение (72 или 150 DPI) или PDF поменьше.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
  },

  excelVPdf: {
    submit: 'Конвертировать в PDF',
    classifying: 'Анализируем таблицу…',
    loadingLocal: 'Конвертируем локально…',
    again: 'Конвертировать ещё',
    resultTitle: 'Конвертация завершена',
    downloadPdf: 'Скачать PDF',
    pdfLabel: 'PDF',
    dropHint: 'Файл не уходит на сервер: конвертация идёт в браузере',
    convertError: 'Не удалось прочитать таблицу. Файл может быть повреждён или защищён паролем.',
    tooManyRows: 'В книге больше 50 000 строк: браузер с ней не справится. Разбейте таблицу на части.',
    wideNotice: 'Таблица широкая: длинные значения могли обрезаться. Проверьте PDF или уберите лишние колонки.',
  },

  numeraciyaStranic: {
    h1: 'Нумерация страниц PDF онлайн',
    intro:
      'Добавьте номера страниц в PDF-документ. Выберите положение номера, стартовый номер и страницу начала нумерации. Обработка локально в браузере — файл не отправляется на сервер.',
    positionLegend: 'Положение номера',
    positionBottomCenter: 'Снизу по центру',
    positionBottomRight: 'Снизу справа',
    positionTopRight: 'Сверху справа',
    startNumberLabel: 'Стартовый номер',
    startPageLabel: 'Начать со страницы',
    submit: 'Добавить номера',
    loading: 'Добавляем номера…',
    again: 'Нумеровать ещё',
    totalPages: 'Страниц',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
    startPageTooHigh: 'В PDF всего {pages} страниц. Укажите страницу начала не больше этого числа.',
  },

  watermarkPdf: {
    h1: 'Добавить водяной знак в PDF онлайн',
    intro:
      'Добавьте свой текстовый водяной знак на все страницы PDF. Настройте текст, прозрачность, положение и угол. Всё выполняется локально в браузере — файл не отправляется на сервер.',
    defaultText: 'Образец',
    textLabel: 'Текст водяного знака',
    textPlaceholder: 'Например: Черновик',
    opacityLabel: 'Прозрачность',
    positionLegend: 'Положение',
    positionCenter: 'По центру',
    positionTopLeft: 'Сверху слева',
    positionBottomRight: 'Снизу справа',
    positionDiagonal: 'Диагонально',
    angleLegend: 'Угол',
    summaryTitle: 'Проверьте настройки перед скачиванием',
    summaryText: 'Текст',
    summaryOpacity: 'Прозрачность',
    summaryPosition: 'Положение',
    summaryAngle: 'Угол',
    textEmpty: 'Не задан',
    submit: 'Добавить водяной знак',
    loading: 'Добавляем знак…',
    again: 'Добавить ещё',
    totalPages: 'Страниц',
    emptyText: 'Введите текст водяного знака.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось обработать PDF. Файл может быть повреждён.',
  },

  protectPdf: {
    passwordLabel: 'Пароль открытия',
    repeatPasswordLabel: 'Повторите пароль',
    passwordWarning:
      'pdfy не хранит пароль и не сможет восстановить файл. Сохраните пароль отдельно перед отправкой защищённого PDF.',
    submit: 'Поставить пароль',
    loading: 'Шифруем PDF…',
    downloadProtected: 'Скачать защищённый PDF',
    again: 'Защитить другой PDF',
    passwordTooShort: 'Пароль должен быть не короче 4 символов.',
    passwordMismatch: 'Пароли не совпадают. Проверьте оба поля.',
    encryptedInput: 'Этот PDF уже защищён паролем или зашифрован. Сначала снимите защиту.',
    encryptError: 'Не удалось защитить PDF. Файл может быть повреждён или не поддерживается QPDF.',
  },

  deletePdfPages: {
    h1: 'Удалить страницы из PDF онлайн',
    intro:
      'Загрузите PDF, укажите лишние страницы и скачайте новый документ без них. Обработка локальная — файл не отправляется на сервер.',
    pagesLabel: 'Страницы для удаления',
    rangesPlaceholder: 'Например: 2,5-7',
    rangesHintPrefix: 'Через запятую: отдельные страницы и диапазоны, например ',
    rangesHintSuffix: '.',
    pageCount: 'страниц: {pages}',
    totalPages: 'Всего страниц',
    removedPages: 'Будет удалено',
    remainingPages: 'Останется страниц',
    submit: 'Удалить страницы',
    loading: 'Удаляем страницы…',
    reading: 'Считаем страницы PDF…',
    again: 'Удалить из другого PDF',
    invalidRanges: 'Не удалось распознать страницы. Пример: 2,5-7',
    outOfRange: 'В PDF всего {pages} страниц. Укажите номера внутри документа.',
    reversedRange: 'Диапазон должен идти по возрастанию: например, 5-7, а не 7-5.',
    emptyResult: 'Нельзя удалить все страницы — в PDF должна остаться хотя бы одна страница.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
  },

  reorderPdfPages: {
    h1: 'Поменять порядок страниц PDF онлайн',
    intro:
      'Загрузите PDF, расставьте страницы в нужном порядке и скачайте новый файл. Всё выполняется локально — исходный PDF не отправляется на сервер.',
    pageCount: 'страниц: {pages}',
    pagesTitle: 'Порядок страниц',
    currentPosition: 'Позиция {page}',
    originalPage: 'исходная {page}',
    dragHandle: 'Перетащить страницу',
    moveUp: 'Переместить страницу {page} выше',
    moveDown: 'Переместить страницу {page} ниже',
    resetOrder: 'Сбросить порядок',
    changedSummary: 'Изменено позиций: {count}',
    noChanges: 'Порядок пока совпадает с исходным PDF.',
    largePdf:
      'В документе {pages} страниц. Используем стабильные плитки без рендера миниатюр и покажем прогресс при пересборке, чтобы браузер не зависал без обратной связи.',
    progressTitle: 'Собираем новый PDF',
    progressPages: 'Страница {current} из {total}',
    totalPages: 'Всего страниц',
    movedPages: 'Страниц изменили позицию',
    submit: 'Собрать PDF',
    loading: 'Собираем PDF…',
    reading: 'Считаем страницы PDF…',
    again: 'Изменить другой PDF',
    singlePage: 'В этом PDF одна страница — менять порядок нечего.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось обработать PDF. Файл может быть повреждён.',
  },

  nUpPdf: {
    sourcePages: 'Страниц в исходном PDF: {count}',
    replaceFile: 'Заменить файл',
    pagesPerSheet: 'Страниц на листе',
    pagesPreset: '{count} на листе',
    paperSize: 'Формат бумаги',
    orientation: 'Ориентация',
    portrait: 'Книжная',
    landscape: 'Альбомная',
    margin: 'Поля',
    gap: 'Интервал',
    pageOrder: 'Порядок страниц',
    across: 'По строкам',
    down: 'По столбцам',
    dimensions: 'Фактический размер листа: {width} × {height} мм',
    pageLimit: 'до {count} страниц',
    previewTitle: 'Предпросмотр итоговых листов',
    previewError: 'Не удалось показать страницы, но экспорт всё ещё доступен.',
    previewLimited: 'Показаны первые {shown} из {total} листов.',
    outputSheets: 'Итоговых листов: {count}',
    sheetLabel: 'Лист {count}',
    submit: 'Собрать PDF для печати',
    loading: 'Собираем PDF…',
    resultSummary: 'Листов: {sheets} · размер файла: {size}',
    again: 'Другой PDF',
    errors: {
      tooLarge: 'PDF превышает лимит 100 МБ.',
      tooManyPages: 'Поддерживается не более {count} исходных страниц.',
      encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
      emptyDocument: 'В PDF нет страниц. Выберите документ хотя бы с одной страницей.',
      invalidLayout: 'Поля и интервалы не помещаются на выбранном листе.',
      parseError: 'Не удалось обработать PDF. Файл может быть повреждён.',
    },
  },

  mergePdf: {
    h1: 'Объединить PDF онлайн',
    intro:
      'Соедините несколько PDF-файлов в один документ. Меняйте порядок файлов перед объединением. Всё обрабатывается в браузере и не отправляется на сервер.',
    pickLabel: 'Выберите PDF-файлы',
    dragPdfs: 'Перетащите PDF сюда или ',
    filesLabel: 'Файлы для объединения',
    minFilesHint: 'Добавьте как минимум 2 PDF-файла для объединения',
    moveUp: 'Переместить выше',
    moveDown: 'Переместить ниже',
    clearAll: 'Очистить всё',
    submit: 'Объединить PDF',
    loading: 'Объединяем…',
    again: 'Объединить ещё',
    mergedFiles: 'Объединено файлов',
    totalPages: 'Всего страниц',
    noPdf: 'Загрузите хотя бы один PDF-файл.',
    encrypted: 'Один из файлов защищён паролем — снимите защиту перед объединением.',
    parseError: 'Не удалось обработать один из файлов. Возможно, файл повреждён.',
  },

  splitPdf: {
    h1: 'Разделить PDF онлайн',
    intro:
      'Извлеките нужные страницы из PDF в новый файл. Укажите диапазон страниц — всё обрабатывается локально в браузере и не отправляется на сервер.',
    pickLabel: 'Выберите PDF-файл',
    rangesLabel: 'Страницы для извлечения',
    rangesPlaceholder: 'Например: 1-3, 7, 10-12',
    rangesAria: 'Диапазоны страниц для извлечения',
    rangesHintPrefix: 'Через запятую: отдельные страницы и диапазоны, например ',
    rangesHintSuffix: '.',
    totalPages: '{pages} страниц',
    totalPagesLabel: 'Всего страниц',
    selectedPages: 'Выбрано страниц',
    emptyRanges: 'Укажите хотя бы одну страницу.',
    invalidRanges: 'Не удалось распознать диапазон. Пример: 1-3, 7, 10-12',
    outOfRange: 'В PDF всего {pages} страниц. Укажите страницы в пределах документа.',
    reversedRange: 'Диапазон должен идти по возрастанию: 3-5, а не 5-3.',
    inspecting: 'Читаем PDF…',
    submit: 'Извлечь страницы',
    loading: 'Извлекаем…',
    again: 'Разделить ещё',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
  },

  cropPdf: {
    h1: 'Обрезать PDF онлайн',
    intro:
      'Загрузите PDF, задайте отступы или перетащите рамку предпросмотра и скачайте обрезанный файл. Всё работает локально в браузере.',
    pageCount: 'страниц: {pages}',
    previewLabel: 'Визуальная рамка обрезки',
    previewHint:
      'Перетащите верхнюю, правую, нижнюю или левую грань рамки. Те же значения можно точно поправить в миллиметрах ниже.',
    marginsLabel: 'Отступы для обрезки, мм',
    marginTop: 'Сверху',
    marginRight: 'Справа',
    marginBottom: 'Снизу',
    marginLeft: 'Слева',
    marginsHint: 'Отступы применяются ко всем страницам PDF.',
    firstPageSize: 'Размер первой страницы',
    minPageSize: 'Минимальная страница',
    dimensionValue: '{width} × {height} мм',
    pagesProcessed: 'Обрезано страниц',
    firstPageCrop: 'Видимая область первой страницы',
    reading: 'Читаем размеры PDF…',
    submit: 'Обрезать PDF',
    loading: 'Обрезаем…',
    again: 'Обрезать другой PDF',
    emptyCrop: 'Задайте хотя бы один отступ или перетащите рамку обрезки.',
    invalidMargins: 'Отступы должны быть нулём или положительным числом.',
    tooLargeCrop:
      'Такие отступы оставляют пустую или слишком маленькую страницу. Уменьшите значения.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
    dragTop: 'Перетащить верхнюю границу обрезки',
    dragRight: 'Перетащить правую границу обрезки',
    dragBottom: 'Перетащить нижнюю границу обрезки',
    dragLeft: 'Перетащить левую границу обрезки',
  },

  redactPdf: {
    pageCount: 'страниц: {pages}',
    boxCount: 'зон: {count}',
    limitsTitle: 'Это не визуальная накладка поверх PDF',
    limitsBody:
      'Результат пересобирается как image-only PDF: страницы рендерятся в изображения, зоны замазываются на пикселях, исходный текстовый слой и ссылки не переносятся. Это честное решение без юридической гарантии redaction.',
    reading: 'Готовим предпросмотр страниц…',
    editorTitle: 'Выделите зоны для замазки',
    editorHint:
      'Протяните прямоугольник мышью или пальцем поверх текста. Нажмите на уже созданный прямоугольник, чтобы удалить его.',
    pageLabel: 'Страница {page}',
    pageBoxCount: 'зон: {count}',
    previewAria: 'Предпросмотр страницы {page}',
    removeBox: 'Удалить зону замазки',
    noBoxesHint: 'Добавьте хотя бы одну зону на предпросмотре, чтобы пересобрать PDF.',
    noBoxes: 'Добавьте хотя бы одну зону замазки.',
    openingPdf: 'Открываем PDF…',
    pageOf: 'Обрабатываем страницу {current} из {total}',
    submit: 'Замазать и пересобрать PDF',
    loading: 'Пересобираем…',
    clear: 'Очистить',
    again: 'Замазать другой PDF',
    pagesProcessed: 'Обработано страниц',
    boxesApplied: 'Применено зон',
    resultNote:
      'Новый PDF состоит из изображений страниц. Текст под зонами не копируется, но поиск по тексту, ссылки и формы в результате не сохраняются.',
    encrypted: 'PDF защищён паролем — снимите защиту и попробуйте снова.',
    renderError:
      'Не удалось отрендерить страницы в браузере. Попробуйте меньший PDF или закройте лишние вкладки.',
    parseError: 'Не удалось прочитать PDF. Файл может быть повреждён.',
  },

  povernut: {
    h1: 'Повернуть PDF онлайн',
    intro:
      'Поверните страницы PDF на 90°, 180° или 270°. Все страницы или выбранный диапазон. Файл обрабатывается прямо в браузере и не отправляется на сервер.',
    angleLegend: 'Угол поворота',
    pagesLegend: 'Какие страницы',
    pagesAll: 'Все страницы',
    pagesRanges: 'Выбранные',
    rangesPlaceholder: 'Например: 1,3,5-7',
    rangesAria: 'Диапазоны страниц',
    rangesHintPrefix: 'Через запятую: отдельные страницы и диапазоны, например ',
    rangesHintSuffix: '.',
    invalidRanges: 'Не удалось распознать диапазоны страниц. Пример: 1,3,5-7',
    submit: 'Повернуть PDF',
    loading: 'Поворачиваем…',
    again: 'Повернуть ещё',
    rotatedCount: 'Повёрнуто страниц',
    encrypted: 'PDF защищён паролем — снимите защиту перед поворотом.',
    parseError: 'Не удалось обработать PDF. Файл может быть повреждён.',
  },

  blog: {
    breadcrumb: 'Блог',
    indexH1: 'Блог pdfy',
    indexIntro:
      'Гайды и заметки про работу с PDF, локальную обработку файлов и инструменты pdfy.',
    empty: 'В этой локали постов пока нет. Переключите язык, чтобы посмотреть, что доступно.',
    updated: 'Обновлено',
    faqHeading: 'Частые вопросы',
    relatedToolsLabel: 'Связанные инструменты',
    relatedToolsHeading: 'Связанные инструменты',
    backToBlog: '← Все посты блога',
    notFoundTitle: 'Пост не найден',
    notFoundBody: 'Возможно, ссылка устарела или адрес введён с ошибкой.',
    notFoundDoc: 'Пост не найден — pdfy.ru',
    otherLanguage: 'Этот пост написан на {language}.',
    viewTranslation: 'Открыть перевод на {language}',
  },

  seo: {
    index: {
      title: 'Все инструменты для работы с PDF онлайн, бесплатно — pdfy.ru',
      description:
        'Сжать, конвертировать, повернуть PDF онлайн. Бесплатно, без регистрации, без водяных знаков. Работает в браузере на любом устройстве.',
    },
    pdfKonverter: {
      title: 'PDF конвертер онлайн бесплатно — pdfy.ru',
      description:
        'Конвертируйте Excel, HTML, изображения и PDF прямо в браузере. Бесплатные инструменты для работы с PDF — без регистрации и водяных знаков.',
    },
    blog: {
      title: 'Блог pdfy — гайды по работе с PDF',
      description:
        'Заметки и пошаговые гайды про PDF: сжатие, конвертация, поворот, локальная обработка в браузере.',
    },
  },
}

export type Translations = typeof ruTranslations
